/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa loan calculator BIB
 *
 */

Intesa.LoanCalculatorBIB = function() {

    console.log("started");

    /**
     * Local variables
     *
     */
    var loan = this;
    var development = false;
    var invalidJsonFiles = false;
    var genericSettings = {};
    var calculatorLabels = {};
    var isEur = true;
    var middleExchangeRateActive = 0;
    var interestRateActive = 0;
    var currentSelectedUniversalCase = '';
    var feeValue = 0;
    /**
     * Global variables
     *
     */
    this.MAX_ITERATIONS = 50;
    this.activeCalculator = null;
    this.activeVariant = {};
    this.activeMortgage = {};
    this.activeCurrency = {};
    this.activeInterestType = {};
    this.errorState = false;
    this.defaultEducation = null;
    // values
    this.loanAmount = 0;
    this.firstInterestRate = 0;
    this.secondInterestRate = 0;
    // terzo
    this.thirdInterestRate = 0;
    this.tenor = 0;
    this.tenorUnit = null;
    this.stepTenor = [];
    this.firstMonthlyInstallment = 0;
    this.firstInterestRateCode = '';
    this.secondMonthlyInstallment = 0;
    this.firstMonthlyInstallmentRsd = 0;
    this.firstMonthlyInstallmentEur = 0;
    this.amountToRepay = 0;
    this.currency = null;
    this.apr = 0;
    this.aprc = 0;
    this.aprc2 = 0;
    this.fee = 0;
    this.notaryCost = 0;
    this.paymentsHistoryFirstPeriod = []; //full list of montly installments 
    this.paymentsHistoryWholePeriod = []; //full list of montly installments 
    this.p = []; // full loan plan 
    this.urlParams = {};
    this.isWithMortgage = $('[data-algorithm-input="mortgage"]').length > 0;

    this.min_approval_cost = 0;
    this.max_approval_cost = 0;
    this.approval_cost = 0;
    this.downPayment = 0;
    this.downPaymentPercentage = parseInt($('[data-algorithm-input="downPayment"]').attr("data-down-min"));
    this.downPaymentPercentageMortgage = parseInt($('[data-algorithm-input="downPaymentPercentuage"]').attr("data-down-min"));
    this.errorDownState === true;
    this.downPaymentPercentuageUnder30 = false;
    this.downpaymentPercentuageFix20 = $('[data-fixed-percentuage-downpayment]') ? true : false;
    var endpoint = window.location.origin + $("input[name=exchangeRate]").val();
    console.log("endpoint " + endpoint);
    this.typeLoan = "";
    this.endpoint = endpoint;
    this.fixedInterestRate = 0;
    this.variableInterestRate = 0;
    this.newInterestRate = 0;
    this.nominalInterestRate = 0;
    this.newNominalInterestRate = 0;
    this.middleExchangeRate = 0;
    this.newMiddleExchangeRate = 0;
    this.secondCurrency = '';
    this.amountToRepayRsd = 0;
    this.firstMonthlyInstallmentEurInterestRate = 0;
    this.firstMonthlyInstallmentRsdInterestRate = 0;
    this.firstMonthlyInstallmentAfterExchangeRate = 0;
    this.firstMonthlyInstallmentAfterVInterestRateExchangeRate = 0;
    this.repaymentPlan = [];
    this.tenorTre = 0;
    this.tenorQuattro = 0;
    this.changedActiveTab = false;
    this.originalVal = "";
    this.customer = true;
    this.clientSegment = "";
    this.otherLoan = true;


    this.getJsonAjax = function(element, endpoint) {
        console.log("invoked url: " + endpoint);
        $.ajax({
                method: "GET",
                async: false,
                url: endpoint
            })
            .done(function(data) {
                if (data != null) {
                    console.log("----" + JSON.stringify(data) + "----");
                    $(element).val(JSON.stringify(data));
                    loan.setUniversalMiddleExchangeRates(JSON.parse(JSON.stringify(data)));

                }
            });
    }

    /**
     * Init component
     *
     */
    this.init = function() {

        // get settings and labels
        loan.getSettingsAndLabelsJsonData();

        // check if calculator exixts
        var isBIB = $('html').attr('data-bank') == 'BIB';
        if (!$("section.com16-14").length || !isBIB || invalidJsonFiles) return;
		if (loan.typeLoan != 'combined') {
			console.log("not combined loan");
	        // handle education special case
	        // loan.handleEducationCalculators();
	
	        // init methods
	        if (loan.typeLoan == 'Universal Loan') {
	            loan.getJsonAjax($("#jsonExchange"), loan.endpoint);
	        }
	        loan.setVisibleCalculatorAsActive();
		    var calculatorNavigation = Intesa.CalculatorNavigation.getInstance(loan.activeCalculator);
		    calculatorNavigation.init();
	        loan.setActiveVariant();
	        loan.setActiveMortgage(loan.getDefaultMortgage());
	        loan.setActiveCurrency(loan.getDefaultCurrency());
	        loan.setTabInitValue();
	        loan.setActiveInterestType(loan.getDefaultInterestType());
	        
			loan.clientSegment = $(".massBtn", loan.activeCalculator).parent().text().trim();
			
	        loan.mapSliders();
	
	        // update calculator
	        loan.initCalculatorInputs();
	        loan.updateCalculatorOutputs();
	
	        // attach on change events
	        loan.attachChangeEvents();
	
	        // trigger click on default education
	        loan.triggerDefaultEducation();
	
	        // get URL query params
	        loan.getUrlQueryStringParams();
	
	        // fill inputs with query params
	        loan.fillInputsWithQueryParams();

	
	        // set downPayment
	        //if ($('[data-algorithm-input=downpaymentPercentuage]').val())
	        //    loan.setDownPayment();
	
	        if ($('[data-algorithm-input="currencySelect"]', loan.activeCalculator).length > 0) {
	            //se sono nel car loan aggiorno la currency con default euro
	            loan.setActiveCurrencyCarLoan("EUR");
	            loan.updateCurrencySelect();
	        }
	        loan.hideValueForIntermezzo();
	       	loan.hideValueForRefinanceWithOtherLoanOption();
            if(loan.typeLoan == "newCarLoan"){
            	loan.updateTenorSlider();
            }
        }

    };

    /**
     * Set Tab Init Value
     *
     */
    this.setTabInitValue = function() {

        if (loan.urlParams && loan.urlParams.isDefault) {

            var activeTab = loan.urlParams.isDefault === 'false' ? false : true;

            loan.setActiveTab(activeTab, true, undefined);

        } else {

            var c;
            // cerca la variante di default
            // cerca la currency di default 
            // cerca il glConfigurationList di default

            var variantList = loan.activeVariant.glProductVariantList;

            var isWithoutSalaryTransfer = -1;

            var calcConfig;

            for (i = 0;
                (i < variantList.length && isWithoutSalaryTransfer === -1); i++) {

                if (variantList[i]['default'] === true) {

                    var currencyList = variantList[i].glConfigurationList;

                    for (j = 0; j < (currencyList.length && isWithoutSalaryTransfer === -1); j++) {

                        if (currencyList[j]['default'] === true) {

                            var configList = currencyList[j].glGenericCalculationList;

                            for (k = 0;
                                (k < configList.length && isWithoutSalaryTransfer === -1); k++) {

                                if (configList[k]['default'] === true) {

                                    isWithoutSalaryTransfer = configList[k]['isDefault'];

                                    calcConfig = configList[k];

                                    break;

                                }

                            }

                        }


                    }

                }

            }

            if (calcConfig && calcConfig.standard) {

                loan.setActiveTab(false, true, calcConfig);

            } else {


                loan.setActiveTab(true, true, calcConfig);

            }


        }

    };

    this.setTabInitValueCarLoan = function() {
        if (loan.urlParams && loan.urlParams.isDefault) {

            var activeTab = loan.urlParams.isDefault === 'false' ? false : true;

            loan.setActiveTab(activeTab, true, undefined);

        } else {

            var c;
            // cerca la variante di default
            // cerca la currency di default 
            // cerca il glConfigurationList di default

            var variantList = loan.activeVariant.glProductVariantList;

            var isWithoutSalaryTransfer = -1;

            var calcConfig;

            for (i = 0;
                (i < variantList.length && isWithoutSalaryTransfer === -1); i++) {

                if (variantList[i].variantId == loan.activeMortgage.variantId) {

                    var currencyList = variantList[i].glConfigurationList;

                    for (j = 0; j < (currencyList.length && isWithoutSalaryTransfer === -1); j++) {

                        if (currencyList[j]['default'] === true) {

                            var configList = currencyList[j].glGenericCalculationList;

                            for (k = 0;
                                (k < configList.length && isWithoutSalaryTransfer === -1); k++) {

                                if (configList[k]['default'] === true) {

                                    isWithoutSalaryTransfer = configList[k]['isDefault'];

                                    calcConfig = configList[k];

                                    break;

                                }

                            }

                        }


                    }

                }

            }

            if (calcConfig && calcConfig.standard) {

                loan.setActiveTab(false, true, calcConfig);

            } else {


                loan.setActiveTab(true, true, calcConfig);

            }


        }
    };

    /**
     * Get Url Query String Params
     *
     */
    this.getUrlQueryStringParams = function() {

        // get url
        var currentURL = window.location.href;
        currentURL = currentURL.split('?');

        // get query params
        var queryString = currentURL[1];

        // check query string not empty
        if (queryString !== undefined) {

            var params = queryString.split('&');

            params.forEach(function(param) {

                var property = param.split('=');
                var propertyName = property[0];
                var propertyValue = property[1];

                // set loan.urlParams property
                loan.urlParams[propertyName] = propertyValue;

            });

        }

    };

    /**
     * Fill Inputs With Query Params
     *
     */
    this.fillInputsWithQueryParams = function() {

        var thereAreQueryParams = $.isEmptyObject(loan.urlParams) ? false : true;

        if (thereAreQueryParams) {

            //set the loan purpose
            //	loan.setLoanPurposeFromQuery();			

            // set interest rate
            loan.setInterestRateFromQuery();

            //set mortgage
            loan.setMortgageFromQuery();

            // set loan amount
            loan.setLoanAmountFromQuery();

            // set currency
            loan.setCurrencyFromQuery();

            // set tenor
            loan.setTenorFromQuery();

        }

    };

    /**
     * Set Currency From Query
     *
     */
    this.setCurrencyFromQuery = function() {

        var currencyUrl = loan.urlParams.currency;
        var currencyUrlSelect = $('[data-algorithm-input="currency"]', loan.activeCalculator);

        if (currencyUrl && currencyUrlSelect.length) {

            currencyUrlSelect.val(currencyUrl).trigger("change");

        }

    };

    /**
     * Set Loan purpose From Query
     *
     */
    this.setLoanPurposeFromQuery = function() {

        // var loanpurpose = loan.urlParams.loanpurpose;
        // var loanpurposeElement = $( '[data-filter="'+loanpurpose+'"]' );

        // if ( loanpurpose && loanpurposeElement.length ) {

        // 	loanpurposeElement.trigger("click");
        // 	loan['loanpurpose'] = loanpurpose;

        // 	loan['sliderNumnber'] = $('[data-filter]').index(loanpurposeElement);

        // }

    };


    /**
     * Set Loan Amount From Query
     *
     */
    this.setLoanAmountFromQuery = function() {

        var loanAmount = loan.urlParams.loanAmount;
        // var loanpurpose = loan.urlParams.loanpurpose;
        // var loanpurposeElement = $( '[data-filter="'+loanpurpose+'"]' );		

        if (loanAmount && !isNaN(loanAmount)) {

            //loanAmount = parseInt(loanAmount.replaceAll(/\s/g, ''));
            loanAmount = parseInt(loanAmount.split(/\s/g).join(''));
            var loanAmountInput = $('[data-algorithm-input="loanAmount"]', loan.activeCalculator);

            // if ( loanpurpose && loanpurposeElement.length ) {
            // 	loanAmountInput = $( '[data-algorithm-input="loanAmount"]',loanpurposeElement );
            // }			

            loanAmountInput.val(loanAmount);
            loan.formatMoneyInputs();

        }

    };

    this.setDownpaymentPercentuage = function() {

        var loanAmount = $('[data-algorithm-input="loanAmount"]', loan.activeCalculator).val();
        var downPaymentInput = $('[data-algorithm-input="downPayment"]', loan.activeCalculator);
        var downPaymentInputPercentuage = $('[data-algorithm-input="downPaymentPercentuage"]', loan.activeCalculator);
        if (loanAmount && !isNaN(loanAmount) && downPaymentInput.length > 0) {

            //loanAmount = parseInt(loanAmount.replaceAll(".", "").replaceAll(/\s/g, ''));
            loanAmount = parseInt(loanAmount.split('.').join('').split(/\s/g).join(''));
            var loanAmountInput = $('[data-algorithm-input="loanAmount"]', loan.activeCalculator);
            loan["downPayment"] = 0;
            loan.downPayment = loanAmountInput.val() * loan.downPaymentPercentageMortgage / 100;
            downPaymentInput.val(loan.downPayment);
            downPaymentInput.attr('data-parsley-min', loan.downPayment);
            if (loan.typeLoan == 'Universal Loan') {
                downPaymentInput.attr('data-parsley-max', Number.MAX_VALUE);
                console.log("set max value universal ");
            } else {
                downPaymentInput.attr('data-parsley-max', loanAmountInput.val());
            }
            downPaymentInputPercentuage.val(loan.downPaymentPercentageMortgage);
            loan.formatMoneyInputs();


        } else {
            loan["downPayment"] = 0;
        }

    };


    /**
     * Set Interest Rate From Query
     *
     */
    this.setInterestRateFromQuery = function() {

        var interestRateType = loan.urlParams.interestRateType;
        var interestRateTypeSelect = $('[name="interestRateType"]',  loan.activeCalculator);

        if (interestRateType && interestRateTypeSelect.length) {

            interestRateTypeSelect.val(interestRateType).trigger("change");

        }

    };

    /**
     * Set Mortgage From Query
     *
     */
    this.setMortgageFromQuery = function() {

        var mortgage = loan.urlParams.mortgage;
        var mortgageContainer = $('[data-algorithm-input="mortgage"]');

        if (mortgage && mortgageContainer.length) {

            $("[name=radio][value=" + mortgage + "]", mortgageContainer).trigger("click");

        }

    };


    /**
     * Set Tenor From Query
     *
     */
    this.setTenorFromQuery = function() {

        var tenor = parseInt(loan.urlParams.tenor);
        // var loanpurpose = loan.urlParams.loanpurpose;
        // var curSlider = $( 'div[data-filter="'+loanpurpose+'"] .rangeslider' );

        if (tenor && !isNaN(tenor)) {

            // get step value
            var step = $('[data-slider-repayment]',  loan.activeCalculator).attr('data-slider-step');
            step = parseInt(step);

            // round tenor based on step
            tenor = tenor - (tenor % step);

            //convert in years
            if (loan.tenorUnit === 'YEARS') {
                tenor = tenor / 12;
            }

            if (loan.typeLoan != 'Universal Loan') {
                window.sliderbootstrap[0].slider('setValue', tenor, true);
                window.sliderbootstrap[0].slider({ tooltip: 'show' });
            } else {
                for (i = 0; i < window.sliderbootstrap.length; i++) {
                    window.sliderbootstrp[i].slider({ tooltip: 'show' });
                    window.sliderbootstrap[i].slider('setValue', tenor, true);
                }
            }

        }

    };

    //hide value for intermezzo
    this.hideValueForIntermezzo = function() {
        if (loan.activeVariant.productId == '10021' ||
            loan.activeVariant.productId == '10022' ||
            loan.activeVariant.productId == '10023' ||
            loan.activeVariant.productId == '16111' ||
            loan.activeVariant.productId == '16112' ||
            loan.activeVariant.productId == '16311' ||
            loan.activeVariant.productId == '17111' ||
            loan.activeVariant.productId == '17112' ||
            loan.activeVariant.productId == '17311' ||
            loan.activeVariant.productId == '30041' ||
            loan.activeVariant.productId == '30042' ||
            loan.activeVariant.productId == '30043' ||
            loan.activeVariant.productId == '20031' ||
            loan.activeVariant.productId == '20032' ||
            loan.activeVariant.productId == '20033' ||
            loan.activeVariant.productId == '40051' ||
            loan.activeVariant.productId == '40052' ||
            loan.activeVariant.productId == '40053' ||
            loan.activeVariant.productId == '40151' ||
            loan.activeVariant.productId == '40152' ||
            loan.activeVariant.productId == '40153') {
            $('.sliderRange__wrapper .fakelabel .valShow')[0].style.display = "none";
            $('.sliderRange__wrapper .fakelabel span:last').before('<span class="rangeslider--value valueShow">' + loan.tenor + ' </span>');
            $('.sliderRange__wrapper .tooltip-inner')[0].style.display = "none";
            document.getElementsByClassName("tooltip")[0].innerHTML = "<div class='tooltip-inner'>" + loan.tenor + " </div><div class='tooltip-arrow'></div>";
        }
    }
    
  //hide value for refinance with other loan options
    this.hideValueForRefinanceWithOtherLoanOption = function() {
        if ((loan.activeVariant.productId == '20031' ||
            loan.activeVariant.productId == '20032' ||
            loan.activeVariant.productId == '20041' ||
            loan.activeVariant.productId == '20042') && $(".otherLoanContainer").length > 0) {
            $('.refinance-other-loan').hide();
        }
    }


    this.calcAprc = function(paymentsList, loanAmount) {
        return loan.calcAprcWithBinarySearch(paymentsList, loanAmount, 0.0, 1.0, 0);
    }

    /*
     * minValue = minimum possible aprc
     * maxValue = maximum possible aprc
     */
    this.calcAprcWithBinarySearch = function(payments, s, minValue, maxValue, iterationLvl) {
        // check if the interval is zero or less than certain decimal places
        if ((maxValue - minValue) < 0.00000000000001) { // rounded to the fourth decimal place
            return minValue;
        }

        // guessing APRC with binary search
        const aprc = (maxValue - minValue) / 2 + minValue;

        // check if we have maximized the iterations
        if (iterationLvl > loan.MAX_ITERATIONS) {
            return aprc;
        }

        const leftSideOfTheEquation = s;
        var rightSideOfTheEquation = 0.0;
        for (var i = 0; i < payments.length; i++) {
            const Ak = payments[i];
            rightSideOfTheEquation += Ak * Math.pow(1 + aprc, -(i + 1.0) / 12.0);
        }

        // check if the aprc is correct guessed
        if (leftSideOfTheEquation == rightSideOfTheEquation) {
            return aprc;
        } else if (leftSideOfTheEquation < rightSideOfTheEquation) {
            return loan.calcAprcWithBinarySearch(payments, s, aprc, maxValue, ++iterationLvl);
        } else { // leftSideOfTheEquation > rightSideOfTheEquation
            return loan.calcAprcWithBinarySearch(payments, s, minValue, aprc, ++iterationLvl);
        }
    }


    /**
     * Get Settings And Labels Json Data
     *
     */
    this.getSettingsAndLabelsJsonData = function() {

        var settings = $("#genericSettings");
        var labels = $("#calculatorLabels");
        var typeLoan = $("#typeloan");

        try {

            // get generic settings
            if (settings.length) {
                genericSettings = JSON.parse(settings.val());
            }

            // get calculator labels
            if (labels.length) {
                calculatorLabels = JSON.parse(labels.val());
            }

            if (typeLoan.length > 0) {
                loan.typeLoan = typeLoan.val();
            }

        } catch (e) {

            console.error('Settings or Labels JSON file invalid');
            invalidJsonFiles = true;

        }

    };

    this.hideUnusedInput = function() {
        var activeCurrency = loan.activeCurrency.currency;
        var activeInterestType = loan.activeInterestType.interestCode;

        if (activeCurrency == 'RSD' && activeInterestType == 'FIXED') {
            $(".divToHideEurFixed").css("display", '');
            $(".divToHideRsdVariable").css("display", '');
            $('.divToHide').css("display", "none");
            currentSelectedUniversalCase = 'rsd-fixed'
        } else if (activeCurrency == 'RSD' && activeInterestType == 'VARIABLE') {
            $(".divToHideEurFixed").css("display", '');
            $('.divToHide').css("display", "");
            $(".divToHideRsdVariable").css("display", 'none');
            currentSelectedUniversalCase = 'rsd-variable'
        } else if (activeCurrency == 'EUR' && activeInterestType == 'FIXED') {
            $('.divToHide').css("display", "");
            $(".divToHideRsdVariable").css("display", '');
            $(".divToHideEurFixed").css("display", 'none');
            currentSelectedUniversalCase = 'eur-fixed'
        } else {
            $('.divToHide').css("display", "block");
            $(".divToHideRsdVariable").css("display", 'block');
            $(".divToHideEurFixed").css("display", 'block');
            currentSelectedUniversalCase = 'eur-variable'
        }

    }

    /**
     * Update Calculator Inputs
     *
     */
    this.initCalculatorInputs = function() {

        loan.updateInterestTypeSelect();
        loan.updatePeriodLines();
        loan.initLoanAmountInput();
        if ($('[data-algorithm-input="downPaymentPercentuage"]',  loan.activeCalculator).val())
            loan.setDownpaymentPercentuage();
        loan.toggleDownPaymentInputLine(isEur);
        loan.updateCurrencySelect();
        loan.updateTenorUnit();
        loan.updateTenorSlider();
        loan.updateTenorStep();

        // tenor mobile
        loan.updateTenorSelect();
        loan.updateTenorInput();

        loan.updateMortgageRadio();
        loan.updateFee();
        loan.updateNotaryCost();
        loan.formatMoneyInputs();
        if (loan.typeLoan == "Universal Loan") {
            loan.hideUnusedInput();
            loan.setUniversalInterestRates();
        }

    };

    /**
     * Update Calculator Inputs
     *
     */
    this.updateCalculatorInputs = function() {
        console.log("update input");
        loan.updateInterestTypeSelect();
        loan.updatePeriodLines();
        loan.updateLoanAmountInput();
        loan.toggleDownPaymentInputLine(isEur);
        //if ($('[data-algorithm-input="downPayment"]').val())
        //    loan.setDownPayment();
        //if(loan.typeLoan != "carLoan")
        loan.updateCurrencySelect();
        if (loan.typeLoan == "consumerLoan" || loan.typeLoan == "energyEfficencyLoan") {
        	loan.formatMoneyInputs();
            loan.updateTenorMaintainStepSlider();
            loan.updateTenorSelect();
        }
        loan.updateTenorUnit();
        loan.updateTenorStep();
        if (loan.typeLoan == "carLoan" ) {
        	loan.updateTenorSlider();
            loan.updateTenorSelect();
        }
        //		loan.updateTenorSlider();
        loan.updateMortgageRadio();
        loan.updateFee();
        loan.updateNotaryCost();
        loan.formatMoneyInputs();
        if (loan.typeLoan == "Universal Loan") {
            loan.hideUnusedInput();
            loan.updateUniversalInterestRates();
            loan.updateInterestsSection();
        }

    };

    this.calculateFirstMonthlyInstallmentAfterVInterestRateExchangeRate = function() {
        var loanAmount = loan.loanAmount;

        var loanDurationInYear = loan.tenor / 12;

        // full loan payment plan
        var paymentList = [];

        // calculate first period payment plan 
        var p1 = loan.p; //loan.piano(loanAmount, loanDurationInYear, parseFloat(interestRateActive), 12);
        var pianoUniversal = loan.repaymentPlan; //loan.pianoUniversal(loanAmount, loanDurationInYear, parseFloat(interestRateActive), 12);
        // second period plan  
        var p2 = [];

        var p1FirstPayment = [];
        var p1LastPayment = [];
        var p2FirstPayment = [];
        var p2LastPayment = [];

        // if there are multiple periods:
        var is2PeriodLoan = ((loan.activeInterestType.secondPeriod !== undefined) && (loan.tenor > loan.activeInterestType.firstPeriod.monthDuration));


        p1LastPayment = p1[p1.length - 1];
        p1FirstPayment = p1[0];

        // get the first period montly installment 
        var convertRate = 1 / parseFloat(loan.newMiddleExchangeRate.toString().replace(",", "."));

        if ($(".rangeslider--3",  loan.activeCalculator).parent().parent().parent().parent().css("display") != 'none') {
            console.log("period 2");
            var rangeVal = parseInt($(".rangeslider--3",  loan.activeCalculator).val());
            var rangeVal4 = parseInt($(".rangeslider--4",  loan.activeCalculator).val());
            // get paymnent detail at the beginning and at the end of the first period 
            p1LastPayment = p1[rangeVal - 1];
            p1FirstPayment = p1[0];

            // get residual debit from first period 
            var debitoResiduo = loan.getDebitoRes(p1LastPayment);
            if (debitoResiduo > 0) {
                // calculate the second plan starting from the residual debit 
                // of the first period and using a different interest rate
                var ir2 = parseFloat(loan.newNominalInterestRate.toString().replace(",", "."));
                var p2 = loan.piano(debitoResiduo, (loan.tenor - rangeVal) / 12, ir2, 12);
                var pianoUniversal2 = loan.pianoUniversal(debitoResiduo, (loan.tenor - rangeVal) / 12, ir2, 12);
                // just need the montly installment so can get any index in p2
                p2FirstPayment = p2[0];

                paymentToUse = [];

                if (loan.activeCurrency.currency == 'RSD') {
                    loan.firstMonthlyInstallmentAfterVInterestRateExchangeRate = parseFloat(loan.firstMonthlyInstallmentEurInterestRate.toString().replace(",", ".")) * convertRate;
                } else {
                    loan.firstMonthlyInstallmentAfterVInterestRateExchangeRate = parseFloat(loan.firstMonthlyInstallmentEurInterestRate.toString().replace(",", ".")) * parseFloat(loan.newMiddleExchangeRate.toString().replace(",", "."));

                }

                //                var primoPianoAmm = [];
                //                var pianoAmmUniv = [];
                //                for(i = 0; i < rangeVal; i++){
                //                	primoPianoAmm.push(p1[i]);
                //                }
                //                
                //                var counter = 0;
                //                for(i = primoPianoAmm.length; i < p1.length; i++){
                //                	primoPianoAmm.push(p2[counter]);
                //                	counter++;
                //                }
                //                
                //                loan.p = primoPianoAmm;
                //                
                //                for (c = 0; c < rangeVal; c++) {
                //                	pianoAmmUniv.push(pianoUniversal[c]);	
                //                }
                //                
                //                counter = 0;
                //                
                //                for (c = pianoAmmUniv.length; c < pianoUniversal.length; c++) {
                //                	pianoAmmUniv.push(pianoUniversal2[c]);	
                //                	counter++;
                //                }
                //                
                //                loan.repaymentPlan = pianoAmmUniv;
            }


        } else if (debitoResiduo == 0) {
            if (loan.activeCurrency.currency == 'RSD') {
                loan.firstMonthlyInstallmentAfterVInterestRateExchangeRate = parseFloat(loan.getRata(p1FirstPayment)) * convertRate;
            } else {
                loan.firstMonthlyInstallmentAfterVInterestRateExchangeRate = parseFloat(loan.getRata(p1FirstPayment)) * parseFloat(middleExchangeRateActive.toString().replace(",", "."));

            }
        }

    }

    this.calculateFirstMonthlyInstallmentEurInterestRate = function() {
        var loanAmount = loan.loanAmount;

        var loanDurationInYear = loan.tenor / 12;

        // full loan payment plan
        var paymentList = [];

        // calculate first period payment plan 
        var p1 = loan.p; //loan.piano(loanAmount, loanDurationInYear, loan.newNominalInterestRate, 12);
        var pianoUniversal = loan.repaymentPlan; //loan.pianoUniversal(loanAmount, loanDurationInYear, loan.newNominalInterestRate, 12);

        // second period plan  
        var p2 = [];

        // full loan plan
        //        loan.p = [];
        //        loan.repaymentPlan = [];

        var p1FirstPayment = [];
        var p1LastPayment = [];
        var p2FirstPayment = [];
        var p2LastPayment = [];

        // if there are multiple periods:
        var is2PeriodLoan = ((loan.activeInterestType.secondPeriod !== undefined) && (loan.tenor > loan.activeInterestType.firstPeriod.monthDuration));


        p1LastPayment = p1[p1.length - 1];
        p1FirstPayment = p1[0];

        if ($(".rangeslider--3",  loan.activeCalculator).parent().parent().parent().parent().css("display") != 'none') {
            console.log("period 2");
            var rangeVal = parseInt($(".rangeslider--3",  loan.activeCalculator).val());
            var rangeVal4 = parseInt($(".rangeslider--4",  loan.activeCalculator).val());

            var middleExchangeRateActiveToUse = 0;
            if (rangeVal < rangeVal4) {
                middleExchangeRateActiveToUse = loan.middleExchangeRate;
            } else {
                middleExchangeRateActiveToUse = loan.newMiddleExchangeRate;
            }
            // get the first period montly installment 
            var convertRate = 1 / parseFloat(middleExchangeRateActiveToUse.toString().replace(",", "."));

            // get paymnent detail at the beginning and at the end of the first period 
            p1LastPayment = p1[rangeVal - 1];
            p1FirstPayment = p1[0];

            // get residual debit from first period 
            var debitoResiduo = loan.getDebitoRes(p1LastPayment);
            if (debitoResiduo > 0) {
                // calculate the second plan starting from the residual debit 
                // of the first period and using a different interest rate
                var ir2 = loan.newNominalInterestRate.toString().replace(",", ".");
                var p2 = loan.piano(debitoResiduo, (loan.tenor - rangeVal) / 12, ir2, 12);
                var pianoUniversal2 = loan.pianoUniversal(debitoResiduo, (loan.tenor - rangeVal) / 12, ir2, 12);
                // just need the montly installment so can get any index in p2
                p2FirstPayment = p2[0];

                if (loan.activeCurrency.currency == 'RSD') {
                    loan.firstMonthlyInstallmentEurInterestRate = parseFloat(loan.getRata(p2FirstPayment)) * convertRate;
                } else {
                    loan.firstMonthlyInstallmentEurInterestRate = parseFloat(loan.getRata(p2FirstPayment));

                }

                var primoPianoAmm = [];
                var pianoAmmUniv = [];
                for (i = 0; i < rangeVal; i++) {
                    primoPianoAmm.push(p1[i]);
                }

                var counter = 0;
                for (i = primoPianoAmm.length; i < p1.length; i++) {
                    primoPianoAmm.push(p2[counter]);
                    counter++;
                }

                loan.p = primoPianoAmm;

                for (c = 0; c < rangeVal; c++) {
                    pianoAmmUniv.push(pianoUniversal[c]);
                }

                counter = 0;

                for (c = pianoAmmUniv.length; c < loan.repaymentPlan.length; c++) {
                    //cambio in numero di rata
                    pianoUniversal2[counter][0] = c + 1;
                    pianoAmmUniv.push(pianoUniversal2[counter]);
                    counter++;
                }

                loan.repaymentPlan = pianoAmmUniv;
            }

        } else if (debitoResiduo == 0) {
            if (loan.activeCurrency.currency == 'RSD') {
                loan.firstMonthlyInstallmentEurInterestRate = parseFloat(loan.getRata(p1FirstPayment)) * convertRate;
            } else {
                loan.firstMonthlyInstallmentEurInterestRate = parseFloat(loan.getRata(p1FirstPayment));

            }

        }

    }

    this.calculateFirstMonthlyInstallmentRsdInterestRate = function() {

        var loanAmount = loan.loanAmount;

        var loanDurationInYear = loan.tenor / 12;

        // full loan payment plan
        var paymentList = [];

        // calculate first period payment plan 
        var p1 = loan.p; //loan.piano(loanAmount, loanDurationInYear, loan.newNominalInterestRate, 12);
        var pianoUniversal = loan.repaymentPlan; //loan.pianoUniversal(loanAmount, loanDurationInYear, loan.newNominalInterestRate, 12);

        // second period plan  
        var p2 = [];

        var p1FirstPayment = [];
        var p1LastPayment = [];
        var p2FirstPayment = [];
        var p2LastPayment = [];

        // if there are multiple periods:
        var is2PeriodLoan = ((loan.activeInterestType.secondPeriod !== undefined) && (loan.tenor > loan.activeInterestType.firstPeriod.monthDuration));



        p1LastPayment = p1[p1.length - 1];
        p1FirstPayment = p1[0];

        console.log("calculateFirstMonthlyInstallmentRsdInterestRate");
        if ($(".rangeslider--3",  loan.activeCalculator).parent().parent().parent().parent().css("display") != 'none') {
            console.log("period 2");
            var rangeVal = parseInt($(".rangeslider--3",  loan.activeCalculator).val());
            var rangeVal4 = parseInt($(".rangeslider--4",  loan.activeCalculator).val());
            // get paymnent detail at the beginning and at the end of the first period 
            p1LastPayment = p1[rangeVal - 1];
            p1FirstPayment = p1[0];

            // get residual debit from first period 
            var debitoResiduo = loan.getDebitoRes(p1LastPayment);
            if (debitoResiduo > 0) {
                // calculate the second plan starting from the residual debit 
                // of the first period and using a different interest rate
                var ir2 = loan.newNominalInterestRate.toString().replace(",", ".");
                var p2 = loan.piano(debitoResiduo, (loan.tenor - rangeVal) / 12, ir2, 12);
                var pianoUniversal2 = loan.pianoUniversal(debitoResiduo, (loan.tenor - rangeVal) / 12, ir2, 12);
                // just need the montly installment so can get any index in p2
                p2FirstPayment = p2[0];
                var middleExchangeRateActiveToUse = 0;
                if (rangeVal < rangeVal4) {
                    middleExchangeRateActiveToUse = loan.middleExchangeRate;
                } else {
                    middleExchangeRateActiveToUse = loan.newMiddleExchangeRate;
                }
                if (currentSelectedUniversalCase == 'rsd-variable') {
                    middleExchangeRateActiveToUse = loan.middleExchangeRate;
                }
                if (currentSelectedUniversalCase == 'eur-variable') {
                    middleExchangeRateActiveToUse = loan.middleExchangeRate;
                }

                if (loan.activeCurrency.currency == 'RSD') {
                    loan.firstMonthlyInstallmentRsdInterestRate = parseFloat(loan.firstMonthlyInstallmentEurInterestRate.toString().replace(",", "."));
                } else {
                    loan.firstMonthlyInstallmentRsdInterestRate = parseFloat(loan.firstMonthlyInstallmentEurInterestRate.toString().replace(",", ".")) * parseFloat(middleExchangeRateActiveToUse.toString().replace(",", "."));

                }
                if (currentSelectedUniversalCase == 'rsd-variable') {
                    if (loan.activeCurrency.currency == 'RSD') {
                        loan.firstMonthlyInstallmentRsdInterestRate = parseFloat(loan.getRata(p2FirstPayment));
                    } else {
                        loan.firstMonthlyInstallmentRsdInterestRate = parseFloat(loan.getRata(p2FirstPayment)) * parseFloat(middleExchangeRateActiveToUse.toString().replace(",", "."));

                    }
                }



                var primoPianoAmm = [];
                var pianoAmmUniv = [];
                for (i = 0; i < rangeVal; i++) {
                    primoPianoAmm.push(p1[i]);
                }

                var counter = 0;
                for (i = primoPianoAmm.length; i < p1.length; i++) {
                    primoPianoAmm.push(p2[counter]);
                    counter++;
                }

                loan.p = primoPianoAmm;

                for (c = 0; c < rangeVal; c++) {
                    pianoAmmUniv.push(pianoUniversal[c]);
                }

                counter = 0;

                for (c = pianoAmmUniv.length; c < loan.repaymentPlan.length; c++) {
                    pianoUniversal2[counter][0] = c + 1;
                    pianoAmmUniv.push(pianoUniversal2[counter]);
                    counter++;
                }

                loan.repaymentPlan = pianoAmmUniv;

            } else if (debitoResiduo == 0) {
                if (loan.activeCurrency.currency == 'RSD') {
                    loan.firstMonthlyInstallmentRsdInterestRate = parseFloat(loan.getRata(p1FirstPayment));
                } else {
                    loan.firstMonthlyInstallmentRsdInterestRate = parseFloat(loan.getRata(p1FirstPayment)) * parseFloat(middleExchangeRateActive.toString().replace(",", "."));

                }
            }

        }
    }

    this.calculateFirstMonthlyInstallmentAfterExchangeRate = function() {

        var loanAmount = loan.loanAmount;

        var loanDurationInYear = loan.tenor / 12;

        // full loan payment plan
        var paymentList = [];

        // calculate first period payment plan 
        var p1 = loan.p; //loan.piano(loanAmount, loanDurationInYear, loan.firstInterestRate, 12);
        var pianoUniversal = loan.repaymentPlan; //loan.pianoUniversal(loanAmount, loanDurationInYear, loan.firstInterestRate, 12);


        // second period plan  
        var p2 = [];

        var p1FirstPayment = [];
        var p1LastPayment = [];
        var p2FirstPayment = [];
        var p2LastPayment = [];

        // if there are multiple periods:
        var is2PeriodLoan = ((loan.activeInterestType.secondPeriod !== undefined) && (loan.tenor > loan.activeInterestType.firstPeriod.monthDuration));

        p1LastPayment = p1[p1.length - 1];
        p1FirstPayment = p1[0];

        if ($(".rangeslider--4",  loan.activeCalculator).parent().parent().parent().parent().css("display") != 'none') {
            console.log("period 2");
            var rangeVal = parseInt($(".rangeslider--4",  loan.activeCalculator).val());
            // get paymnent detail at the beginning and at the end of the first period 
            p1LastPayment = p1[rangeVal - 1];
            p1FirstPayment = p1[0];

            // get residual debit from first period 
            var debitoResiduo = loan.getDebitoRes(p1LastPayment);
            if (debitoResiduo > 0) {
                // calculate the second plan starting from the residual debit 
                // of the first period and using a different interest rate
                var ir2 = parseFloat(loan.firstInterestRate.toString().replace(",", "."));
                var p2 = loan.piano(debitoResiduo, (loan.tenor - rangeVal) / 12, ir2, 12);
                var pianoUniversal2 = loan.pianoUniversal(debitoResiduo, (loan.tenor - rangeVal) / 12, ir2, 12);
                // just need the montly installment so can get any index in p2
                p2FirstPayment = p2[0];

                if (loan.activeCurrency.currency == 'RSD') {
                    loan.firstMonthlyInstallmentAfterExchangeRate = parseFloat(loan.getRata(p1LastPayment));
                } else {
                    loan.firstMonthlyInstallmentAfterExchangeRate = parseFloat(loan.getRata(p1LastPayment)) * parseFloat(loan.newMiddleExchangeRate.toString().replace(",", "."));

                }

                //                var primoPianoAmm = [];
                //                var pianoAmmUniv = [];
                //                for(i = 0; i < rangeVal; i++){
                //                	primoPianoAmm.push(p1[i]);
                //                }
                //                
                //                var counter = 0;
                //                for(i = primoPianoAmm.length; i < p1.length; i++){
                //                	primoPianoAmm.push(p2[counter]);
                //                	counter++;
                //                }
                //                
                //                loan.p = primoPianoAmm;
                //                
                //                for (c = 0; c < rangeVal; c++) {
                //                	pianoAmmUniv.push(pianoUniversal[c]);	
                //                }
                //                
                //                counter = 0;
                //                
                //                for (c = pianoAmmUniv.length; c < pianoUniversal.length; c++) {
                //                	pianoAmmUniv.push(pianoUniversal2[c]);	
                //                	counter++;
                //                }
                //                
                //                loan.repaymentPlan = pianoAmmUniv;

            } else if (debitoResiduo == 0) {
                if (loan.activeCurrency.currency == 'RSD') {
                    loan.firstMonthlyInstallmentAfterExchangeRate = parseFloat(loan.getRata(p1FirstPayment));
                } else {
                    loan.firstMonthlyInstallmentAfterExchangeRate = parseFloat(loan.firstMonthlyInstallmentEur.toString().replace(",", ".")) * parseFloat(middleExchangeRateActive.toString().replace(",", "."));

                }
            }

        }

    }

    /**
     * Update Calculator Outputs
     *
     */
    this.updateCalculatorOutputs = function() {
        if ($('[data-algorithm-input="downPaymentPercentuage"]',  loan.activeCalculator).val())
            loan.updateDownpaymentPercentuage();

        loan.getCalculatorInputs();
        loan.getTenorInMonths();
        loan.getInterestRates();
        loan.calculateMonthlyInstallments();
        if (loan.typeLoan == 'Universal Loan') {
            loan.calculateFirstMonthlyInstallmentRsd();
            console.log(currentSelectedUniversalCase);
            if (currentSelectedUniversalCase == 'eur-fixed' || currentSelectedUniversalCase == 'eur-variable') {
                loan.calculateFirstMonthlyInstallmentEur();
            }
            if (currentSelectedUniversalCase == 'eur-fixed' || currentSelectedUniversalCase == 'eur-variable') {
                loan.calculateFirstMonthlyInstallmentAfterExchangeRate();
            }
            if (currentSelectedUniversalCase == 'eur-variable') {
                loan.calculateFirstMonthlyInstallmentEurInterestRate();
            }
            if (currentSelectedUniversalCase == 'rsd-variable' || currentSelectedUniversalCase == 'eur-variable') {
                loan.calculateFirstMonthlyInstallmentRsdInterestRate();
            }
            if (currentSelectedUniversalCase == 'eur-variable') {
                loan.calculateFirstMonthlyInstallmentAfterVInterestRateExchangeRate();
            }
        }
        loan.calculateAmountToRepay();
        if (loan.typeLoan == 'Universal Loan') {
            loan.calculateAmountToRepayRsd();
        }
        loan.getPaymentListByPlan();
        loan.updateFee();
        var initialExpenses = loan.getInitialExpenses(loan.loanAmount, loan.fee, loan.notaryCost, loan.isWithMortgage);
        loan.calculateAPRC(initialExpenses, 0);
        loan.checkErrors();
        if ($('[data-algorithm-input="downPayment"]',  loan.activeCalculator).val() !== "0" && $('[data-algorithm-input="downPayment"]',  loan.activeCalculator).length > 0)
            loan.checkDownValueError();
        loan.checkGeneralError();
        loan.appendCalculatorOutputs();
        if (development) loan.consoleLogValues();
        if (loan.typeLoan == 'Universal Loan') {
            loan.setPianoDiAmmortamento();
        }

        //toggle show status
        $("[data-showStatus]",  loan.activeCalculator).hide();

        if (loan.isWithMortgage) {
            $('[data-aprc="notary_cost"]',  loan.activeCalculator).show();
        } else {
            $('[data-aprc="notary_cost"]',  loan.activeCalculator).hide();
        }

        $('[data-aprc="first"]',  loan.activeCalculator).show();
        $('[data-aprc="second"]',  loan.activeCalculator).hide();

        // update share calculator
        loan.updateShareCalculatorLink();

        // update input hidden
        loan.updateContactInputHidden();

        if (loan.typeLoan == "Universal Loan") {
            loan.hideUnusedInput();
        }

        if (loan.activeVariant.productId == '10021' ||
            loan.activeVariant.productId == '10022' ||
            loan.activeVariant.productId == '10023' ||
            loan.activeVariant.productId == '16111' ||
            loan.activeVariant.productId == '16112' ||
            loan.activeVariant.productId == '16311' ||
            loan.activeVariant.productId == '17111' ||
            loan.activeVariant.productId == '17112' ||
            loan.activeVariant.productId == '17311' ||
            loan.activeVariant.productId == '30041' ||
            loan.activeVariant.productId == '30042' ||
            loan.activeVariant.productId == '30043' ||
            loan.activeVariant.productId == '20031' ||
            loan.activeVariant.productId == '20032' ||
            loan.activeVariant.productId == '20033' ||
            loan.activeVariant.productId == '40051' ||
            loan.activeVariant.productId == '40052' ||
            loan.activeVariant.productId == '40053' ||
            loan.activeVariant.productId == '40151' ||
            loan.activeVariant.productId == '40152' ||
            loan.activeVariant.productId == '40153') {
            document.getElementsByClassName("tooltip")[0].innerHTML = "<div class='tooltip-inner'>" + loan.tenor + "</div><div class='tooltip-arrow'></div>";
        }

    };


    /**
     * Update downpayment percentuage of mortage
     *
     */
    this.updateDownpaymentPercentuage = function() {
      //var loanAmount = parseInt($('[data-algorithm-input="loanAmount"]', loan.activeCalculator).val().replaceAll(".", "").replaceAll(/\s/g, ''));
        var loanAmount = parseInt($('[data-algorithm-input="loanAmount"]', loan.activeCalculator).val().split('.').join('').split(/\s/g).join(''));
      //var downPaymentInput = parseInt($('[data-algorithm-input="downPayment"]').val().replaceAll(/\./g, '').replaceAll(/\s/g, ''));
        var downPaymentInput = parseInt($('[data-algorithm-input="downPayment"]',  loan.activeCalculator).val().split(/\./g).join('').split(/\s/g).join(''));
        var percentuage = (100 * downPaymentInput) / loanAmount;
        $('[data-algorithm-input="downPaymentPercentuage"]',  loan.activeCalculator).val(percentuage);
        if (percentuage == 30) {
            loan.downPaymentPercentuageUnder30 = true;
        } else {

            loan.downPaymentPercentuageUnder30 = false;
        }
    };


    /**	 
     * Update Contact Input Hidden
     *
     */
    this.updateContactInputHidden = function() {

        /*
            TODO: move this data inside a input hidden and remove #test div.
        */
        var data = JSON.stringify({
            LOANAMOUNT: number_format(parseFloat(loan.loanAmount), 2, genericSettings.decimal, genericSettings.separator),
            DURATION: loan.tenor,
            INSTALLMENT: number_format(parseFloat(loan.firstMonthlyInstallment), 2, genericSettings.decimal, genericSettings.separator),
            DISCOUNTCODE: null,
            APR: number_format(parseFloat(loan.aprc), 2, genericSettings.decimal, genericSettings.separator),
            INTERESTRATE: number_format(parseFloat(loan.firstInterestRate), 2, genericSettings.decimal, genericSettings.separator)
        });
        var lang_calculator = $('input[name=loanCalculatorLanguage]').val();
        if (lang_calculator == 'sr' ){
        	data = JSON.stringify({
        		IZNOSKREDITA: number_format(parseFloat(loan.loanAmount), 2, genericSettings.decimal, genericSettings.separator),
        		TRAJANJE: loan.tenor,
        		RATA: number_format(parseFloat(loan.firstMonthlyInstallment), 2, genericSettings.decimal, genericSettings.separator),
        		KODZAPOPUST: null,
                APR: number_format(parseFloat(loan.aprc), 2, genericSettings.decimal, genericSettings.separator),
                KAMATNASTOPA: number_format(parseFloat(loan.firstInterestRate), 2, genericSettings.decimal, genericSettings.separator)
            });
        }

        $('[data-cmb-input]').attr('value', data);
        $('#getloan-calc-config').attr('value', data);

    };


    /**
     * Attach Change Events
     *
     */
    this.attachChangeEvents = function() {

        // on calculator change
        $(document).on('click', '.com15__filterItem', function() {
            var id = $(this).attr('data-filter');
			var width = $(window).width();
			var calculatorResolution = "desktop" ;
			if(width < 768){
				var calculatorResolution = "mobile" ;
			}
            var calculator = $('.com15__filter[data-filter="' + id + '"]').find('[data-calculator='+calculatorResolution+']');
            //	loan['loanpurpose'] = id;
            loan.setActiveCalculator(calculator);
            loan.setActiveVariant();
            loan.setActiveMortgage(loan.getDefaultMortgage());
            loan.setActiveCurrency(loan.getDefaultCurrency());
            loan.setActiveInterestType(loan.getDefaultInterestType());
            loan.initCalculatorInputs();
            loan.updateCalculatorInputs();
            loan.updateCalculatorOutputs();
        });


        $(document).on('click', '.massBtn', function() {
            if (!$(".massBtn", loan.activeCalculator).hasClass("clicked")) {
                $(".upperMassBtn", loan.activeCalculator).removeClass("clicked");
                $(".massBtn", loan.activeCalculator).addClass("clicked");
                loan.clientSegment = $(this).parent().text().trim();
                loan.setActiveVariant();
                if (loan.typeLoan == "carLoan" || loan.typeLoan == "consumerLoan" || loan.typeLoan == "energyEfficencyLoan" || loan.typeLoan == "newCarLoan") {
                    loan.setActiveMortgage(loan.activeMortgage.variantType);
                    loan.setActiveCurrency(loan.currency);
                    loan.setTabInitValueCarLoan();
                } else {
                    loan.setTabInitValue();
                    loan.setActiveMortgage(loan.activeMortgage.variantType);
                    loan.setActiveCurrency(loan.currency);
                }

                loan.setActiveInterestType(loan.activeInterestType.interestCode);
                //    loan.initCalculatorInputs();
                //    loan.updateCalculatorInputs();
                if (loan.typeLoan == "cashLoan" || loan.typeLoan == "refinanceLoan" || loan.typeLoan == "consumerLoan" || loan.typeLoan == "energyEfficencyLoan") {
                	loan.updateCalculatorInputs();
                    loan.updateMaxMinLoanAmount();
                }
                loan.updateCalculatorOutputs();
            }
        });

        $(document).on('click', '.upperMassBtn', function() {
            if (!$(".upperMassBtn", loan.activeCalculator).hasClass("clicked")) {
                $(".massBtn", loan.activeCalculator).removeClass("clicked");
                $(".upperMassBtn", loan.activeCalculator).addClass("clicked");
                loan.clientSegment = $(this).parent().text().trim();
                loan.setActiveVariantUpperMass();

                if (loan.typeLoan == "carLoan" || loan.typeLoan == "consumerLoan" || loan.typeLoan == "energyEfficencyLoan" || loan.typeLoan == "newCarLoan") {
                    loan.setActiveMortgage(loan.activeMortgage.variantType);
                    loan.setActiveCurrency(loan.currency);
                    loan.setTabInitValueCarLoan();
                } else {
                    loan.setTabInitValue();
                    loan.setActiveMortgage(loan.activeMortgage.variantType);
                    loan.setActiveCurrency(loan.currency);
                }
                loan.setActiveInterestType(loan.activeInterestType.interestCode);
                //    loan.initCalculatorInputs();
                //    loan.updateCalculatorInputs();
                if (loan.typeLoan == "cashLoan" || loan.typeLoan == "refinanceLoan" || loan.typeLoan == "consumerLoan" || loan.typeLoan == "energyEfficencyLoan") {
                	loan.updateCalculatorInputs();
                    loan.updateMaxMinLoanAmount();
                }
                loan.updateCalculatorOutputs();
            }
        });

        // on change tab
        $(document).on('click', '[data-tab-default]', function() {

            var defaultValue = $(this).attr('data-tab-default') === 'true';
			loan.customer = defaultValue;
            loan.setActiveTab(defaultValue, false, undefined);
            loan.changeSalaryTransferDataLayer(defaultValue);
            loan.setActiveInterestType(loan.activeInterestType.interestCode);
            //loan.updateCalculatorInputs();
            if (loan.typeLoan == "cashLoan" || loan.typeLoan == "refinanceLoan" || loan.typeLoan == "consumerLoan" || loan.typeLoan == "energyEfficencyLoan") {
            	//loan.initLoanAmountInput();
            	loan.updateMaxMinLoanAmount();
            	loan.updateCalculatorInputs();
            }
            loan.updateCalculatorOutputs();

        });
        
        // on change otherLoan
        $(document).on('click', '[data-tab-otherloan]', function() {

            var defaultValue = $(this).attr('data-tab-otherloan') === 'true';
			loan.otherLoan = defaultValue;
            //loan.updateCalculatorInputs();
			loan.updateCalculatorOutputs();

        });

        $(document).on('keyup change', 'input[data-algorithm-input="fixedInterestRate"]', function() {
            console.log("passing for change function");
            var value = $(this).val().replace(",", ".");
            loan.fixedInterestRate = number_format(parseFloat(value), 2, genericSettings.decimal, genericSettings.separator);

            var nominalSum = parseFloat(loan.fixedInterestRate.toString().replace(",", ".")) + parseFloat(loan.variableInterestRate.toString().replace(",", "."));
            if (currentSelectedUniversalCase == 'rsd-fixed' || currentSelectedUniversalCase == 'eur-fixed') {
                nominalSum = parseFloat(loan.fixedInterestRate.toString().replace(",", "."));
            }
            loan.nominalInterestRate = number_format(nominalSum, 2, genericSettings.decimal, genericSettings.separator);

            var newNominalSum = parseFloat(loan.fixedInterestRate.toString().replace(",", ".")) + parseFloat(loan.newInterestRate.toString().replace(",", "."));
            loan.newNominalInterestRate = number_format(newNominalSum, 2, genericSettings.decimal, genericSettings.separator);
            interestRateActive = loan.newNominalInterestRate;
            loan.updateCalculatorInputs();
            loan.updateCalculatorOutputs();
        });

        $(document).on('keyup input', 'input[data-algorithm-input="variableInterestRate"]', function() {
            console.log("passing for change function");
            var value = $(this).val().replace(",", ".");
            loan.variableInterestRate = number_format(parseFloat(value), 2, genericSettings.decimal, genericSettings.separator);
            var nominalSum = parseFloat(loan.fixedInterestRate.toString().replace(",", ".")) + parseFloat(loan.variableInterestRate.toString().replace(",", "."));
            loan.nominalInterestRate = number_format(nominalSum, 2, genericSettings.decimal, genericSettings.separator);
            interestRateActive = loan.nominalInterestRate;
            loan.updateCalculatorInputs();
            loan.updateCalculatorOutputs();
        });

        $(document).on('keyup input', 'input[data-algorithm-input="newInterestRate"]', function() {
            console.log("passing for change function");
            var value = $(this).val().replace(",", ".");
            loan.newInterestRate = number_format(parseFloat(value), 2, genericSettings.decimal, genericSettings.separator);
            var newNominalSum = parseFloat(loan.fixedInterestRate.toString().replace(",", ".")) + parseFloat(loan.newInterestRate.toString().replace(",", "."));
            loan.newNominalInterestRate = number_format(newNominalSum, 2, genericSettings.decimal, genericSettings.separator);
            loan.updateCalculatorInputs();
            loan.updateCalculatorOutputs();
        });


        $(document).on('keyup', 'input[data-algorithm-input="middleExchangeRate"]', function() {
            console.log("passing for change function");
            var value = $(this).val().replace(",", ".");
            loan.middleExchangeRate = number_format(parseFloat(value), 2, genericSettings.decimal, genericSettings.separator);
            middleExchangeRateActive = loan.middleExchangeRate;
            loan.updateCalculatorInputs();
            loan.updateCalculatorOutputs();
        });

        $(document).on('keyup', 'input[data-algorithm-input="newMiddleExchangeRate"]', function() {
            console.log("passing for change function");
            var value = $(this).val().replace(",", ".");
            loan.newMiddleExchangeRate = number_format(parseFloat(value), 2, genericSettings.decimal, genericSettings.separator);
            middleExchangeRateActive = loan.newMiddleExchangeRate;
            loan.updateCalculatorInputs();
            loan.updateCalculatorOutputs();
        });

        // on change mortgage radio buttons
        $(document).on('change', '[data-algorithm-input="mortgage"] input', function() {
            var value = $(this).val();
            loan.isWithMortgage = (value == 'WITH_MORTGAGE');
            loan.setActiveMortgage(value);
            loan.setActiveCurrency(loan.activeCurrency.currency);
            if (loan.typeLoan == "carLoan" || loan.typeLoan == "newCarLoan") {
                loan.setTabInitValueCarLoan();
                loan.initLoanAmountInput();
            }
            loan.setActiveInterestType(loan.activeInterestType.interestCode);
            if (loan.typeLoan == "carLoan" || loan.typeLoan == "newCarLoan") {
                loan.updateTenorUnit();
                loan.updateTenorSlider();
                loan.updateTenorStep();
            }
            //loan.updateCalculatorInputs();
            loan.updateCalculatorOutputs();
        });

        //on change currency car loan

        $(document).on('change', '[data-algorithm-input="currencySelect"] input', function() {
            var value = $('[data-algorithm-input="currencySelect"] input:checked', loan.activeCalculator).val();
            isEur = (value == 'EUR');
            if (isEur) {
                loan.setActiveCurrencyCarLoan("EUR");
                loan.toggleDownPaymentInputLine(isEur);

            } else {
                loan.setActiveCurrencyCarLoan("RSD");
                loan.toggleDownPaymentInputLine(isEur);
                
            }
            loan.setActiveMortgage(value);
            loan.setActiveCurrency(value);
            loan.setTabInitValueCarLoan();
            loan.setActiveInterestType(loan.getDefaultInterestType());
            loan.initCalculatorInputs();
            //loan.updateCurrencySelect();
            loan.updateCalculatorInputs();
            loan.updateCalculatorOutputs();
        });

        //on change loanAmount update downPayment
        $(document).on('change focusout keyup', '[data-algorithm-input="loanAmount"]', function() {
            var value = $(this).val();
            loan.loanAmount = value;
            loan.updateCalculatorInputs();
            loan.updateCalculatorOutputs();
        });

        //on change downPayment update tenor
        $(document).on('change focusout keyup', '[data-algorithm-input="downPayment"]', function () {
            loan.updateTenorSlider();
            loan.updateTenorSelect();
        });

        // on change currency select
        $(document).on('change', '[data-algorithm-input="currency"]', function() {
    		$('[data-algorithm-input="currencySelect"] input[value]', loan.activeCalculator).removeAttr("checked");
        	if(loan.typeLoan == 'carLoan' ||  loan.typeLoan == "newCarLoan"){
        		var value = $(this).val();
        		if(value == "RSD"){
        			$(this).parents(".tab-mobile").find(".next-btn").attr("onclick", "window.intesa.calculatorNavigation.goToTab(3)");
        			$(this).parents(".mobile-loan").siblings().find(".back-btn").attr("onclick", "window.intesa.calculatorNavigation.goToTab(1)");      		
        		} else {
        			$('[data-algorithm-input="downPayment"]', loan.activeCalculator).parent().find('[data-algorithm-input="currency"]').prop("disabled", true);
        		    $(this).parents(".tab-mobile").find(".next-btn").attr("onclick", "window.intesa.calculatorNavigation.nextPrev(1, this)");      		
        			$(this).parents(".mobile-loan").siblings().find(".back-btn").attr("onclick", "window.intesa.calculatorNavigation.nextPrev(-1, this)");      		       	
        		}
        		$('[data-algorithm-input="currencySelect"] input[value='+value+']', loan.activeCalculator).attr("checked", "checked");
        		$('[data-algorithm-input="currencySelect"] input[value='+value+']', loan.activeCalculator).trigger("change");

        	} else {
	            var value = $(this).val();
	            loan.setActiveCurrency(value);
	            loan.setActiveInterestType(loan.activeInterestType.interestCode);
	            loan.updateCalculatorInputs();
	            loan.updateCalculatorOutputs();
        	}
        });


        // on change interest select
        $(document).on('change', '[data-interest-select]', function() {
            var value = $(this).val();
            loan.setActiveMortgage(value);
            loan.setActiveCurrency(loan.activeCurrency.currency);
            loan.updateCalculatorConfigurationByTenor(loan.tenor, value);
            if(loan.typeLoan == "consumerLoan" || loan.typeLoan == "energyEfficencyLoan"){
                var defaultValue = loan.customer;
                loan.setActiveTab(defaultValue, false, undefined);
                loan.changeSalaryTransferDataLayer(defaultValue);
            }
            loan.setActiveInterestType(value);
            loan.updateTenorSelect();
            loan.updateFee();
            loan.updateCalculatorInputs();
            loan.updateCalculatorOutputs();
        });

		$(document).on('change', "[data-algorithm-input=newInterest] input", function(){
			var value = $( this ).val();
			$("select[data-interest-select]", loan.activeCalculator).val(value);
			$("select[data-interest-select]", loan.activeCalculator).trigger('change');
		});

        // on change inputs
        $(document).on('change focusout keyup', '[data-algorithm-input]', function() {
            if ($(this).get(0).getAttribute("data-algorithm-input") !== "loanAmount" &&
                $(this).get(0).getAttribute("data-algorithm-input") !== "fixedInterestRate" &&
                $(this).get(0).getAttribute("data-algorithm-input") !== "variableInterestRate" &&
                $(this).get(0).getAttribute("data-algorithm-input") !== "newInterestRate")
                loan.updateCalculatorOutputs();
        });


        // on click slider buttons
        $(document).on("click", '.js-btnMinus, .js-btnAdd', function() {

            if (loan.activeVariant.productId == '10021' ||
                loan.activeVariant.productId == '10022' ||
                loan.activeVariant.productId == '10023' ||
                loan.activeVariant.productId == '16111' ||
                loan.activeVariant.productId == '16112' ||
                loan.activeVariant.productId == '16311' ||
                loan.activeVariant.productId == '17111' ||
                loan.activeVariant.productId == '17112' ||
                loan.activeVariant.productId == '17311' ||
                loan.activeVariant.productId == '30041' ||
                loan.activeVariant.productId == '30042' ||
                loan.activeVariant.productId == '30043' ||
                loan.activeVariant.productId == '20031' ||
                loan.activeVariant.productId == '20032' ||
                loan.activeVariant.productId == '20033' ||
                loan.activeVariant.productId == '40051' ||
                loan.activeVariant.productId == '40052' ||
                loan.activeVariant.productId == '40053' ||
                loan.activeVariant.productId == '40151' ||
                loan.activeVariant.productId == '40152' ||
                loan.activeVariant.productId == '40153') {
                if ($(this).hasClass("js-btnMinus")) {
                    loan.originalVal = 'minus';
                    console.log("loan.originalVal " + loan.originalVal);
                } else {
                    loan.originalVal = 'add';
                    console.log("loan.originalVal " + loan.originalVal);
                }
                console.log("aggiornare stepvalue");
                loan.updateTenorStep();
                var value = $('.rangeslider').val();
                console.log("value è: " + value);
                var wrapper = $('.rangeslider').parents('.sliderRange__wrapper');
                wrapper.find('.qty').val(value);
                $('.sliderRange__wrapper .fakelabel .valueShow')[0].textContent = loan.findTenorByIndex(value) + " ";
                $('.sliderRange__wrapper .tooltip-inner')[0].textContent = loan.findTenorByIndex(value) + " ";
                wrapper.find(".tooltip-main").addClass("in");
            } else if (loan.typeLoan != 'Universal Loan') {
                if ($(this).hasClass("js-btnMinus")) {
                    loan.originalVal = 'minus';
                    console.log("loan.originalVal " + loan.originalVal);
                } else {
                    loan.originalVal = 'add';
                    console.log("loan.originalVal " + loan.originalVal);
                }

                console.log("aggiornare stepvalue");
                loan.updateTenorStep();
                var value = $('.rangeslider').val();
                console.log("value è: " + value);
                var wrapper = $('.rangeslider').parents('.sliderRange__wrapper');
                wrapper.find('.qty').val(value);
                wrapper.find(".tooltip-main").addClass("in");

            } else {

                loan.updateTenorStep();
                var value = $(this).parents(".sliderRange__wrapper").find(".rangeslider").val();
                console.log("value è: " + value);
                var wrapper = $(this).parents('.sliderRange__wrapper');
                wrapper.find('.qty').val(value);
                wrapper.find('.valShow').html(value);
                wrapper.find(".tooltip-main").addClass("in");
                if ($(this).parents(".sliderRange__wrapper").find(".rangeslider").hasClass("rangeslider--2")) {
                    var inputSliderTre = $('.rangeslider.rangeslider--3', loan.activeCalculator);
                    var inputSliderQuattro = $('.rangeslider.rangeslider--4', loan.activeCalculator);
                    var wrapperTre = inputSliderTre.parents('.sliderRange__wrapper');
                    var wrapperQuattro = inputSliderQuattro.parents('.sliderRange__wrapper');
                    inputSliderTre.attr('data-slider-max', value);
                    valTre = inputSliderTre.val();
                    valQuattro = inputSliderQuattro.val();
                    wrapperTre.find('[data-max-tenor]').html(value);
                    inputSliderQuattro.attr('data-slider-max', value);
                    wrapperQuattro.find('[data-max-tenor]').html(value);
                    var indexSliderTre = parseInt(inputSliderTre.attr('data-slider-index'));
                    var indexSliderQuattro = parseInt(inputSliderQuattro.attr('data-slider-index'));
                    var sliderTre = window.sliderbootstrap[indexSliderTre];
                    var sliderQuattro = window.sliderbootstrap[indexSliderQuattro];

                    sliderTre.slider('destroy');
                    sliderTre.slider({ tooltip: 'show' });

                    sliderQuattro.slider('destroy');
                    sliderQuattro.slider({ tooltip: 'show' });

                    wrapperTre.find('.qty').val(valTre);
                    wrapperTre.find('.valShow').html(valTre);
                    wrapperQuattro.find('.qty').val(valQuattro);
                    wrapperQuattro.find('.valShow').html(valQuattro);
                    sliderTre.slider('setValue', valTre, true);
                    sliderQuattro.slider('setValue', valQuattro, true);
                    wrapperTre.find(".tooltip-main").addClass("in");
                    wrapperQuattro.find(".tooltip-main").addClass("in");
                }

                //rimuovo la classe da tutti i qty e la aggiungo solo per il tenor cliccato
                $('.rangeslider').parents('.sliderRange__wrapper').find('.qty').removeClass("selected-tenor");
                wrapper.find('.qty').addClass("selected-tenor");

            }

            loan.updateCalculatorOutputs();
        });

        // enable change slider on change
        $('.slider-handle')[0].addEventListener('mouseover mouseup', function(e) {
            $('.sliderRange__wrapper .tooltip-inner')[0].textContent = loan.findTenorByIndex(e.target.getAttribute("aria-valuenow"));
        });

        $(document).on('slide change click', '.rangeslider', function(e) {
            if ((e.type == "slide" || e.type == "mouseup") &&
                (loan.activeVariant.productId == '10021' ||
                    loan.activeVariant.productId == '10022' ||
                    loan.activeVariant.productId == '10023' ||
                    loan.activeVariant.productId == '16111' ||
                    loan.activeVariant.productId == '16112' ||
                    loan.activeVariant.productId == '16311' ||
                    loan.activeVariant.productId == '17111' ||
                    loan.activeVariant.productId == '17112' ||
                    loan.activeVariant.productId == '17311' ||
                    loan.activeVariant.productId == '30041' ||
                    loan.activeVariant.productId == '30042' ||
                    loan.activeVariant.productId == '30043' ||
                    loan.activeVariant.productId == '20031' ||
                    loan.activeVariant.productId == '20032' ||
                    loan.activeVariant.productId == '20033' ||
                    loan.activeVariant.productId == '40051' ||
                    loan.activeVariant.productId == '40052' ||
                    loan.activeVariant.productId == '40053' ||
                    loan.activeVariant.productId == '40151' ||
                    loan.activeVariant.productId == '40152' ||
                    loan.activeVariant.productId == '40153')) {

                $('.sliderRange__wrapper .fakelabel .valueShow')[0].textContent = loan.findTenorByIndex(e.value) + " ";
                $('.sliderRange__wrapper .tooltip-inner')[0].textContent = loan.findTenorByIndex(e.value) + " ";

            } else if (e.type == "change") {

                if (loan.typeLoan != 'Universal Loan') {
                    values = e.value;
                    var oldValue = values.oldValue;
                    var newValue = values.newValue;
                    if (newValue > oldValue) {
                        e.value.newValue = oldValue;
                        $(".js-btnAdd").trigger("click");
                    } else {
                        e.value.newValue = oldValue;
                        $(".js-btnMinus").trigger("click");
                    }
                    if (loan.activeVariant.productId == '10021' ||
                        loan.activeVariant.productId == '10022' ||
                        loan.activeVariant.productId == '10023' ||
                        loan.activeVariant.productId == '16111' ||
                        loan.activeVariant.productId == '16112' ||
                        loan.activeVariant.productId == '16311' ||
                        loan.activeVariant.productId == '17111' ||
                        loan.activeVariant.productId == '17112' ||
                        loan.activeVariant.productId == '17311' ||
                        loan.activeVariant.productId == '30041' ||
                        loan.activeVariant.productId == '30042' ||
                        loan.activeVariant.productId == '30043' ||
                        loan.activeVariant.productId == '20031' ||
                        loan.activeVariant.productId == '20032' ||
                        loan.activeVariant.productId == '20033' ||
                        loan.activeVariant.productId == '40051' ||
                        loan.activeVariant.productId == '40052' ||
                        loan.activeVariant.productId == '40053' ||
                        loan.activeVariant.productId == '40151' ||
                        loan.activeVariant.productId == '40152' ||
                        loan.activeVariant.productId == '40153') {
                        $('.sliderRange__wrapper .fakelabel .valueShow')[0].textContent = loan.findTenorByIndex(newValue) + " ";
                        $('.sliderRange__wrapper .tooltip-inner')[0].textContent = loan.findTenorByIndex(newValue) + " ";
                    }
                } else {
                    var value = $(this).val();
                    console.log("value è:" + value);
                    var wrapper = $(this).parents('.sliderRange__wrapper');
                    wrapper.find('.qty').val(value);
                    wrapper.find('.valShow').html(value);
                }
                loan.updateCalculatorOutputs();
            }
        });

        
		$(document).on('keyup', 'input[data-algorithm-input="loanDuration"]', function () {
            var slider = $('.rangeslider.rangeslider--2', loan.activeCalculator);
            var index = parseInt(slider.attr('data-slider-index'));
            
            window.sliderbootstrap[index].slider('setValue', $(this).val(), true);
		});


		$(document).on('change', '[data-tenor-select]', function () {
            var slider = $('.rangeslider.rangeslider--2', loan.activeCalculator);
            var index = parseInt(slider.attr('data-slider-index'));
                
            if(loan.activeVariant.productId == '10021' ||
                    loan.activeVariant.productId == '10022' ||
                    loan.activeVariant.productId == '10023' ||
                    loan.activeVariant.productId == '16111' ||
                    loan.activeVariant.productId == '16112' ||
                    loan.activeVariant.productId == '16311' ||
                    loan.activeVariant.productId == '17111' ||
                    loan.activeVariant.productId == '17112' ||
                    loan.activeVariant.productId == '17311' ||
                    loan.activeVariant.productId == '30041' ||
                    loan.activeVariant.productId == '30042' ||
                    loan.activeVariant.productId == '30043' ||
                    loan.activeVariant.productId == '20031' ||
                    loan.activeVariant.productId == '20032' ||
                    loan.activeVariant.productId == '20033' ||
                    loan.activeVariant.productId == '40051' ||
                    loan.activeVariant.productId == '40052' ||
                    loan.activeVariant.productId == '40053' ||
                    loan.activeVariant.productId == '40151' ||
                    loan.activeVariant.productId == '40152' ||
                    loan.activeVariant.productId == '40153'){    
                    
		            var step  = loan.findIndexByTenor( parseInt($(this).val()) );
		
		            if( step != -1 ){
		                var wrapper = $(slider).parents('.sliderRange__wrapper');
	                    wrapper.find('.qty').val(step);
	                    wrapper.find('.valShow').html(step);
		                window.sliderbootstrap[index].slider('setValue', step, true);
		            }
            } else {
                    var value = $(this).val();
                    console.log("value è:" + value);
                    var wrapper = $(slider).parents('.sliderRange__wrapper');
                    wrapper.find('.qty').val(value);
                    wrapper.find('.valShow').html(value);
                    window.sliderbootstrap[index].slider('setValue', value, true);
            }
            loan.updateCalculatorOutputs();
            
		});

    };


    /**
     * Trigger Default Education
     *
     */
    this.triggerDefaultEducation = function() {

        if (loan.defaultEducation !== null) {

            $('[data-filter="' + loan.defaultEducation + '"]').trigger('click');

        }

    };


    /**
     * Handle Education Calculators
     *
     */
    this.handleEducationCalculators = function() {

        var educationCalculators = $('[data-education]');

        if (educationCalculators.length) {

            educationCalculators.each(function() {

                var calculator = $(this);
                var calculatorData = loan.getEducationCalculatorDataFromJSON(calculator);
                var variantName = calculator.attr('data-filter');

                if (calculatorData !== null) {

                    // remove other variants from JSON
                    calculatorData = loan.removeEducationVariantsFromJSON(calculatorData, variantName);

                    // set default education
                    var isDefault = calculatorData.glGenericSimulatorParams.glProductVariantList[0].default;
                    if (isDefault) loan.defaultEducation = variantName;

                    // insert new JSON
                    calculatorData = JSON.stringify(calculatorData);
                    calculator.find('.calculatorData').val(calculatorData);

                }

            });

        }

    };


    /**
     * Remove Education Variants From JSON
     *
     */
    this.removeEducationVariantsFromJSON = function(calculatorData, variantName) {

        calculatorData.glGenericSimulatorParams.glProductVariantList.forEach(function(item, index, array) {

            // remove variant if different from variant name
            if (item.variantType !== variantName) {

                array.splice(index, 1);

            }

        });

        return calculatorData;

    };


    /**
     * Get Education Calculator Data From JSON
     *
     */
    this.getEducationCalculatorDataFromJSON = function(calculator) {

        var data = null;
        var calculatorData = calculator.find('.calculatorData').val();

        try {

            data = JSON.parse(calculatorData);

        } catch (e) {

            console.error('Education JSON file invalid');

        }

        return data;

    };


    /**
     * Check Errors
     *
     */
    this.checkErrors = function() {

        // get parsley errors
        var errors = $('.parsley-errors-list li', loan.activeCalculator).length;

        if (errors > 0) {

            loan.errorState = true;

        } else {

            loan.errorState = false;

        }

    };

    this.checkGeneralError = function() {
        var downError = loan.errorDownState;
        // get parsley errors
        var errors = $('.parsley-errors-list li', loan.activeCalculator).length;

        if (errors > 0 || downError) {

            loan.errorState = true;

        } else {

            loan.errorState = false;

        }
    }

    /**
     * Check Car Value Error
     *
     */
    this.checkDownValueError = function() {

        var downPaymentError = $('[data-down-error]', loan.activeCalculator);
        var loanInput = $('[data-algorithm-input="loanAmount"]', loan.activeCalculator);
        var downPaymentInput = $('[data-algorithm-input="downPayment"]', loan.activeCalculator);
        var downPaymentPercentageInput = $('[data-algorithm-input="downPaymentPercentuage"]', loan.activeCalculator);
       //var downPaymentVal = downPaymentInput.val().replaceAll(".", "").replaceAll(/\s/g, '');
        var downPaymentVal = downPaymentInput.val().split('.').join('').split(/\s/g).join('');
        var downPaymentErrors = downPaymentInput.parents('.spaceBottom').find('.parsley-errors-list li');
      //var loanAmount = loanInput.val().replaceAll(".", "").replaceAll(/\s/g, '');
        var loanAmount = loanInput.val().split('.').join('').split(/\s/g).join('');
      //var currentValue = loanInput.val().replaceAll(".", "").replaceAll(/\s/g, '');
        var currentValue = loanInput.val().split('.').join('').split(/\s/g).join('');
        var downPaymentPercent = loan.downPaymentPercentage;

        var downPaymentCheck = parseInt(downPaymentInput.attr("data-down-min"));
        if (downPaymentPercentageInput.length > 0) {
            downPaymentPercent = parseInt(downPaymentPercentageInput.val());
            downPaymentCheck = parseInt(downPaymentPercentageInput.attr("data-down-min"));
        }

        if (downPaymentPercent !== null && downPaymentPercent !== undefined) {

            currentValue = currentValue - (currentValue * (downPaymentPercent / 100));

        } else {


        }
        if (downPaymentInput.length > 0) {
            console.log(currentValue * downPaymentPercent / 100);
            var isDownPaymentMoreThanValue = downPaymentVal > loan.loanAmount;
            var isDownPaymentMinorThanMinimum = downPaymentVal < round((loanAmount * downPaymentCheck) / 100, 0);
            console.log("downPaymentVal:" + downPaymentVal);
            // if input exist
            if (downPaymentError.length > 0) {

                if (isDownPaymentMoreThanValue || isDownPaymentMinorThanMinimum || downPaymentVal == '') {
                    if (loan.typeLoan == 'carLoan' ||  loan.typeLoan == "newCarLoan" && loan.currency == 'RSD') {
                        // hide error
                        this.errorState = false;
                        this.errorDownState = false;
                        downPaymentError.addClass('hide');

                        if (downPaymentErrors.length == 0) {

                            downPaymentInput.removeClass('parsley-error');
                            downPaymentInput.addClass('parsley-success');

                        }
                    } else {
                        // show error
                        this.errorState = true;
                        this.errorDownState = true;
                        downPaymentError.removeClass('hide');

                        downPaymentInput.removeClass('parsley-success');
                        downPaymentInput.addClass('parsley-error');
                    }

                } else {

                    // hide error
                    this.errorState = false;
                    this.errorDownState = false;
                    downPaymentError.addClass('hide');

                    if (downPaymentErrors.length == 0) {

                        downPaymentInput.removeClass('parsley-error');
                        downPaymentInput.addClass('parsley-success');

                    }

                }

            } else {
                // hide error
                this.errorState = false;
                this.errorDownState = false;
                downPaymentError.addClass('hide');

                if (downPaymentErrors.length < 0) {

                    downPaymentInput.addClass('parsley-success');
                    downPaymentInput.removeClass('parsley-error');
                }
            }
        }

    };

    /**
     * Map Sliders
     *
     */
    this.mapSliders = function() {

        var sliders = window.sliderbootstrap;

        // map every slider with its instance inside sliderbootstrap window property
        sliders.forEach(function(item, index) {

            item.attr('data-slider-index', index);

        });

    };


    /**
     * Set Active Calculator
     *
     */
    this.setActiveCalculator = function(calculator) {

        loan.activeCalculator = calculator;

    };


    /**
     * Set Visible Calculator As Active
     *
     */
    this.setVisibleCalculatorAsActive = function() {

		var width = $(window).width();
		var calculatorResolution = "desktop" ;
		if(width < 768){
			var calculatorResolution = "mobile" ;
		}
		var calculators = $( '[data-calculator='+calculatorResolution+']' );
        var calculatorFound = false;

        calculators.each(function() {

            // set visible calculator as active
            if ($(this).is(":visible")) {

                loan.activeCalculator = $(this);
                calculatorFound = true;

            }

        });

        // handle no calculator active by default
        if (!calculatorFound) loan.activeCalculator = $('[data-calculator='+calculatorResolution+']').first();

    };


    /**
     * Get Tenor In Months
     *
     */
    this.getTenorInMonths = function() {

        if (loan.tenorUnit === 'YEARS') loan.tenor = loan.tenor * 12;

    };


    /**
     * Update Fee
     *
     */
    this.updateFee = function() {

        //loan.fee = loan.activeCurrency.glGenericCalculationList[0].fee;
        feeValue = loan.activeTab.data.fee;
        console.log(feeValue);
        if (feeValue != undefined && feeValue != null && feeValue != 'undefined' && feeValue != 'null') {
            if (loan.typeLoan == 'mortgageLoan' || loan.typeLoan == 'carLoan' ||  loan.typeLoan == "newCarLoan") {
                if (loan.activeInterestType.firstLoanRangeAmount !== null && loan.activeInterestType.firstLoanRangeAmount !== undefined && (loan.loanAmount-loan.downPayment) > loan.activeInterestType.firstLoanRangeAmount) {
                    loan.fee = (loan.loanAmount - loan.downPayment) * (0 / 100);
                } else {
                    loan.fee = (loan.loanAmount - loan.downPayment) * (feeValue / 100);
                }
            } else {
                loan.fee = loan.loanAmount * (feeValue / 100);
            }
        } else {
            loan.fee = 0;
        }
        if (isNaN(loan.fee)) {
            loan.fee = 0;
        }
        console.log(loan.fee);
        if (loan.activeTab.data.min_approval_cost != undefined && loan.activeTab.data.min_approval_cost != null && loan.activeTab.data.min_approval_cost != 'undefined' && loan.activeTab.data.min_approval_cost != 'null') {
            loan.min_approval_cost = loan.activeTab.data.min_approval_cost;
        } else {
            loan.min_approval_cost = 0;
        }
        if (loan.activeTab.data.max_approval_cost != undefined && loan.activeTab.data.max_approval_cost != null && loan.activeTab.data.max_approval_cost != 'undefined' && loan.activeTab.data.max_approval_cost != 'null') {
            loan.max_approval_cost = loan.activeTab.data.max_approval_cost;
        } else {
            loan.max_approval_cost = 0;
        }
    };

    /**
     * Update Fee
     *
     */
    this.updateNotaryCost = function() {

        loan.notaryCost = loan.activeTab.data.notary_costs;
        if (loan.notaryCost == null) {
            loan.notaryCost = 0;
        }

    };


    /**
     * Update Tenor Unit
     *
     */
    this.updateTenorUnit = function() {

        // get tenor unit
        loan.tenorUnit = loan.activeCurrency.tenorUnit;

        // get label
        var tenorUnitLabel = calculatorLabels[loan.tenorUnit];

        // insert label
        $('[data-tenor-unit]', loan.activeCalculator).text(tenorUnitLabel);

    };


    /**
     * Get Interest Rates
     *
     */
    this.getInterestRates = function() {

        loan.setFirstInterestRate();
        //console.log(loan.firstInterestRate);
        loan.setSecondInterestRate();
        //console.log(loan.secondInterestRate);

        // setto il terzo
        loan.setThirdInterestRate();
        //	console.log(loan.thirdInterestRate);
    };

    this.setUniversalInterestRates = function() {
        if (loan.activeInterestType.periods === 1) {
            loan.fixedInterestRate = number_format(loan.activeInterestType.firstPeriod.fixedInterestRate, 2, genericSettings.decimal, genericSettings.separator);
            loan.variableInterestRate = number_format(loan.activeInterestType.firstPeriod.variableInterestRate, 2, genericSettings.decimal, genericSettings.separator);
            loan.newInterestRate = number_format(loan.activeInterestType.firstPeriod.newInterestRate, 2, genericSettings.decimal, genericSettings.separator);
            var nominalSum = parseFloat(loan.fixedInterestRate) + parseFloat(loan.variableInterestRate);
            if (currentSelectedUniversalCase == 'rsd-fixed' || currentSelectedUniversalCase == 'eur-fixed') {
                nominalSum = parseFloat(loan.fixedInterestRate);
            }
            loan.nominalInterestRate = number_format(nominalSum, 2, genericSettings.decimal, genericSettings.separator);
            loan.firstInterestRate = loan.nominalInterestRate;
            var newNominalSum = parseFloat(loan.fixedInterestRate) + parseFloat(loan.newInterestRate);
            loan.newNominalInterestRate = number_format(newNominalSum, 2, genericSettings.decimal, genericSettings.separator);
            interestRateActive = loan.newNominalInterestRate;
            $("[data-algorithm-input=fixedInterestRate]").val(loan.fixedInterestRate);
            $("[data-algorithm-input=variableInterestRate]").val(loan.variableInterestRate);
            $("[data-algorithm-input=newInterestRate]").val(loan.newInterestRate);
            $("[data-algorithm-input=nominalInterestRate]").val(loan.nominalInterestRate);
            $("[data-algorithm-input=newNominalInterestRate]").val(loan.newNominalInterestRate);

        }
    }

    this.updateUniversalInterestRates = function() {
        if (loan.activeInterestType.periods === 1) {
            loan.fixedInterestRate = number_format(parseFloat(loan.fixedInterestRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator);
            loan.variableInterestRate = number_format(parseFloat(loan.variableInterestRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator);
            loan.newInterestRate = number_format(parseFloat(loan.newInterestRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator);
            var nominalSum = parseFloat(loan.fixedInterestRate.toString().replace(",", ".")) + parseFloat(loan.variableInterestRate.toString().replace(",", "."));
            if (currentSelectedUniversalCase == 'rsd-fixed' || currentSelectedUniversalCase == 'eur-fixed') {
                nominalSum = parseFloat(loan.fixedInterestRate.toString().replace(",", "."));
            }
            loan.nominalInterestRate = number_format(nominalSum, 2, genericSettings.decimal, genericSettings.separator);
            loan.firstInterestRate = loan.nominalInterestRate;
            var newNominalSum = parseFloat(loan.fixedInterestRate.toString().replace(",", ".")) + parseFloat(loan.newInterestRate.toString().replace(",", "."));
            loan.newNominalInterestRate = number_format(newNominalSum, 2, genericSettings.decimal, genericSettings.separator);
            interestRateActive = loan.newNominalInterestRate;
        }
    }


    this.updateInterestsSection = function() {
        //$("[data-algorithm-input=fixedInterestRate]").val(number_format(parseFloat(loan.fixedInterestRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator));
        //$("[data-algorithm-input=variableInterestRate]").val(number_format(parseFloat(loan.variableInterestRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator));
        //$("[data-algorithm-input=newInterestRate]").val(number_format(parseFloat(loan.newInterestRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator));
        $("[data-algorithm-input=nominalInterestRate]").val(number_format(parseFloat(loan.nominalInterestRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator));
        $("[data-algorithm-input=newNominalInterestRate]").val(number_format(parseFloat(loan.newNominalInterestRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator));
    }

    this.setUniversalMiddleExchangeRates = function(json) {
        $.each(json.rates, function(key, value) {
            var jsonValue = value;
            var toCurrency = jsonValue.toCurrency.label;
            if (toCurrency == 'EUR') {
                loan.middleExchangeRate = number_format(jsonValue.meanRate.rate, 2, genericSettings.decimal, genericSettings.separator);
                loan.newMiddleExchangeRate = number_format(jsonValue.meanRate.rate, 2, genericSettings.decimal, genericSettings.separator);
                middleExchangeRateActive = number_format(jsonValue.meanRate.rate, 2, genericSettings.decimal, genericSettings.separator);
                $("[data-algorithm-input=middleExchangeRate]").val(loan.middleExchangeRate);
                $("[data-algorithm-input=newMiddleExchangeRate]").val(loan.newMiddleExchangeRate);
            }
        });
    }
    
    
    
    /**
     * Set Interest Rate
     *
     */
    this.setInterestRateBasedOnPeriod = function(period) {
    	
    	// RIMUOVERE TUTTO QUESTO IF SE SI SCEGLIE DI MOSTRARE SEMPRE L'OPZIONE OTHER LOAN
    	/*if($(".otherLoanContainer").length > 0){
	    	if(loan.activeInterestType.interestCode != "FIXED" || loan.customer == false){
	    		if(loan.otherLoan == false){
	    			$("[data-tab-otherloan='true']").each(function() {
	    				$(this).parent().click();
					});
	    		}
	    		$(".otherLoanContainer").addClass("hide");
	    		loan.otherLoan = true;
	    	}else{
	    		$(".otherLoanContainer").removeClass("hide");
	    	}
    	}*/
    	
    	var interestRate;

        if (loan.otherLoan == false && loan.activeInterestType.interestCode == "FIXED" && loan.customer == true) {
            if (loan.loanAmount > loan.activeInterestType.noLoanRangeAmount) {
                interestRate = loan.activeInterestType[period].interestRateNoLoanSecondRange;
            }
            else {
                interestRate = loan.activeInterestType[period].interestRateNoLoanFirstRange;
            }
        }
        else if(loan.typeLoan == "carLoan"){
            if (loan.activeInterestType[period].interestRateSecondRange !== null && loan.activeInterestType[period].interestRateSecondRange !== undefined &&
                loan.activeInterestType.firstLoanRangeAmount !== null && loan.activeInterestType.firstLoanRangeAmount !== undefined && loan.activeInterestType.firstLoanRangeAmount !== "0" &&
                 (loan.loanAmount-loan.downPayment) > loan.activeInterestType.firstLoanRangeAmount) {
                interestRate = loan.activeInterestType[period].interestRateSecondRange;
            } else {
                interestRate = loan.activeInterestType[period].interestRate;
            }
        }
        else {
            if (loan.activeInterestType[period].interestRateSecondRange !== null && loan.activeInterestType[period].interestRateSecondRange !== undefined &&
                loan.activeInterestType.firstLoanRangeAmount !== null && loan.activeInterestType.firstLoanRangeAmount !== undefined && loan.activeInterestType.firstLoanRangeAmount !== "0" &&
                 loan.loanAmount > loan.activeInterestType.firstLoanRangeAmount) {
                interestRate = loan.activeInterestType[period].interestRateSecondRange;
            } else {
                interestRate = loan.activeInterestType[period].interestRate;
            }
        }

        return interestRate;
    };
    
    

    /**
     * Set First Interest Rate
     *
     */
    this.setFirstInterestRate = function() {

        // handle multiple interest rate for 1 period. If tenor > firstPeriodDuration set second period interest rate as first.
        if (loan.activeInterestType.periods === 1) {

            // loan.firstInterestRate = loan.activeInterestType.secondPeriod.interestRate;
            loan.updateCalculatorConfigurationByTenor(loan.tenor, loan.activeInterestType.interestCode);
            loan.updateTenorSelect();
            //loan.setActiveCurrency( loan.activeCurrency.currency );
            //loan.setActiveTab(loan.activeTab.isDefault, false);
            loan.setActiveInterestType(loan.activeInterestType.interestCode);
            loan.firstInterestRate = loan.setInterestRateBasedOnPeriod("firstPeriod");

        } else {

            loan.firstInterestRate = loan.setInterestRateBasedOnPeriod("firstPeriod");

        }

    };


    /**
     * Set Second Interest Rate
     *
     */
    this.setSecondInterestRate = function() {

        // if second period exists set it
        if (loan.activeInterestType.periods === 2 && loan.activeInterestType.secondPeriod !== undefined) {

            loan.secondInterestRate = loan.setInterestRateBasedOnPeriod("secondPeriod");

        } else if (loan.activeInterestType.periods === 3 && loan.activeInterestType.secondPeriod !== undefined) {


            loan.secondInterestRate = loan.setInterestRateBasedOnPeriod("secondPeriod");

        } else {

            loan.secondInterestRate = '-';

        }

    };


    /**
     * Set Third Interest Rate
     *
     */
    this.setThirdInterestRate = function() {

        // if second period exists set it
        if (loan.activeInterestType.periods === 3 && loan.activeInterestType.thirdPeriod !== undefined) {

            loan.thirdInterestRate = loan.setInterestRateBasedOnPeriod("thirdPeriod");

        } else {

            loan.thirdInterestRate = '-';

        }

    };




    /**
     * Calculate Monthly Installments
     *
     */
    this.calculateMonthlyInstallments = function() {

        if (loan.activeVariant.productId == '10021' ||
            loan.activeVariant.productId == '10022' ||
            loan.activeVariant.productId == '10023' ||
            loan.activeVariant.productId == '16111' ||
            loan.activeVariant.productId == '16112' ||
            loan.activeVariant.productId == '16311' ||
            loan.activeVariant.productId == '17111' ||
            loan.activeVariant.productId == '17112' ||
            loan.activeVariant.productId == '17311' ||
            loan.activeVariant.productId == '30041' ||
            loan.activeVariant.productId == '30042' ||
            loan.activeVariant.productId == '30043' ||
            loan.activeVariant.productId == '20031' ||
            loan.activeVariant.productId == '20032' ||
            loan.activeVariant.productId == '20033' ||
            loan.activeVariant.productId == '40051' ||
            loan.activeVariant.productId == '40052' ||
            loan.activeVariant.productId == '40053' ||
            loan.activeVariant.productId == '40151' ||
            loan.activeVariant.productId == '40152' ||
            loan.activeVariant.productId == '40153') {
            loan.tenor = loan.findTenorByIndex(loan.tenor);
        }

        var loanAmount = loan.loanAmount;
        //console.log("input exist" + $('[data-algorithm-input="downPayment"]', loan.activeCalculator).length);
        //sottraggo al prestito richiesto il downpayment
        if ($('[data-algorithm-input="downPayment"]', loan.activeCalculator).length > 0) {
            loanAmount = loanAmount - loan.downPayment;
        } else {
            console.log("down payment non presente");
            loan["downPayment"] = 0;
            loan.downPayment = 0;
        }

        var loanDurationInYear = loan.tenor / 12;

        // full loan payment plan
        var paymentList = [];

        // calculate first period payment plan 
        var p1 = loan.piano(loanAmount, loanDurationInYear, loan.firstInterestRate, 12);
        if(loan.typeLoan == "mortgageLoan"){
        	p1 = loan.pianoMortgageLoan(loanAmount, loanDurationInYear, loan.firstInterestRate, 12);
        }
        var pianoUniversal = loan.pianoUniversal(loanAmount, loanDurationInYear, loan.firstInterestRate, 12);

        // second period plan  
        var p2 = [];
        var pianoUniversal2 = [];

        // full loan plan
        loan.p = [];
        loan.repaymentPlan = [];

        var p1FirstPayment = [];
        var p1LastPayment = [];
        var p2FirstPayment = [];
        var p2LastPayment = [];

        // if there are multiple periods:
        // unused declaration:
		//var is2PeriodLoan = ((loan.activeInterestType.secondPeriod !== undefined) && (loan.tenor > loan.activeInterestType.firstPeriod.monthDuration));

		//refactoring multi periods logic
		
		switch(loan.typeLoan == null ? "" : loan.typeLoan){
			case("homeRecostruction"):
			if (loan.activeInterestType.periods === 2 && loan.tenor > loan.activeInterestType.firstPeriod.monthDuration) {
			 	p1 = loan.piano(loanAmount, loanDurationInYear, loan.secondInterestRate, 12);
			}
			break;
			case("mortgageLoan"):
			if (loan.activeInterestType.periods === 2 && loan.tenor > loan.activeInterestType.firstPeriod.monthDuration) {
			 	p1 = loan.pianoMortgageLoan(loanAmount, loanDurationInYear, loan.secondInterestRate, 12);
			}	
			break;
			default:
			if( loan.activeInterestType.periods == 3 && loan.tenor > loan.activeInterestType.secondPeriod.monthDuration){
				p1 = loan.piano(loanAmount, loanDurationInYear, loan.thirdInterestRate, 12);
			}else if ( loan.activeInterestType.periods == 3 || loan.activeInterestType.periods == 2 && loan.tenor > loan.activeInterestType.firstPeriod.monthDuration){
				p1 = loan.piano(loanAmount, loanDurationInYear, loan.secondInterestRate, 12);
			}else{
				p1 = loan.piano(loanAmount, loanDurationInYear, loan.firstInterestRate, 12);
			}
			break;
		}
		
        if (loan.activeInterestType.periods === 2 && loan.typeLoan != "mortgageLoan" && loan.activeInterestType.interestCode && loan.activeInterestType.interestCode.includes("FV")) {
            console.log("period 2");

            // get paymnent detail at the beginning and at the end of the first period 
            p1FirstPayment = p1[0];
            p1LastPayment = p1[loan.activeInterestType.firstPeriod.monthDuration - 1];


            // get the first period montly installment 
            loan.firstMonthlyInstallment = parseFloat(loan.getRata(p1FirstPayment));

            // fill the payment list with the montlyinstallments of the first period +1 
            for (i = 0;
                ((i < p1.length) && (i < loan.activeInterestType.firstPeriod.monthDuration)); i++) {
                loan.p.push(p1[i]);
            }
            for (c = 0;
                (c < pianoUniversal.length && (i < loan.activeInterestType.firstPeriod.monthDuration)); c++) {
                loan.repaymentPlan.push(pianoUniversal[c]);
            }

            // get residual debit from first period 
            var debitoResiduo = loan.getDebitoRes(p1LastPayment);
            if (debitoResiduo > 0) {
                // calculate the second plan starting from the residual debit 
                // of the first period and using a different interest rate
                var ir2 = loan.setInterestRateBasedOnPeriod("secondPeriod");
                p2 = loan.piano(debitoResiduo, (loan.tenor - loan.activeInterestType.firstPeriod.monthDuration) / 12, ir2, 12);
                pianoUniversal2 = loan.pianoUniversal(debitoResiduo, (loan.tenor - loan.activeInterestType.firstPeriod.monthDuration) / 12, ir2, 12);
                // just need the montly installment so can get any index in p2
                p2FirstPayment = p2[0];

                loan.secondMonthlyInstallment = parseFloat(loan.getRata(p2FirstPayment));

                for (i = 0; i < p2.length; i++) {
                    loan.p.push(p2[i]);
                }
                for (c = 0; c < pianoUniversal2.length; c++) {
                    loan.repaymentPlan.push(pianoUniversal2[i]);
                }
            }
            // paymentList.length == loan.tenor

        } else {
            console.log("period 1");

            // Single Period loan 
            loan.secondMonthlyInstallment = '-';

            p1LastPayment = p1[p1.length - 1];
            p1FirstPayment = p1[0];

            // get the first period montly installment 
            loan.firstMonthlyInstallment = parseFloat(loan.getRata(p1FirstPayment));

            for (i = 0; i < p1.length; i++) {
                loan.p.push(p1[i]);
            }
        }
    };

    this.calculateFirstMonthlyInstallmentEur = function() {


        var loanAmount = loan.loanAmount;

        var loanDurationInYear = loan.tenor / 12;

        // full loan payment plan
        var paymentList = [];

        // calculate first period payment plan 
        var p1 = loan.piano(loanAmount, loanDurationInYear, loan.nominalInterestRate.toString().replace(",", "."), 12);
        var pianoUniversal = loan.pianoUniversal(loanAmount, loanDurationInYear, loan.nominalInterestRate.toString().replace(",", "."), 12);

        // second period plan  
        var p2 = [];
        var pianoUniversal2 = [];

        // full loan plan
        //        loan.p = [];
        //        loan.repaymentPlan = [];

        var p1FirstPayment = [];
        var p1LastPayment = [];
        var p2FirstPayment = [];
        var p2LastPayment = [];

        console.log("period 1");

        // Single Period loan 
        loan.secondMonthlyInstallment = '-';

        p1LastPayment = p1[p1.length - 1];
        p1FirstPayment = p1[0];
        var convertRate = 1 / loan.middleExchangeRate.toString().replace(",", ".");
        // get the first period montly installment 
        if (loan.activeCurrency.currency == 'EUR') {
            loan.firstMonthlyInstallmentEur = parseFloat(loan.getRata(p1FirstPayment));
        } else {
            loan.firstMonthlyInstallmentEur = parseFloat(loan.getRata(p1FirstPayment)) * parseFloat(1 / convertRate);
        }

        //        for (i = 0; i < p1.length; i++) {
        //            loan.p.push(p1[i]);
        //        }
        //        for (c = 0; c < pianoUniversal.length; c++) {
        //            loan.repaymentPlan.push(pianoUniversal[c]);
        //        }


    }


    this.calculateFirstMonthlyInstallmentRsd = function() {

        loan.firstInterestRate = loan.nominalInterestRate;

        var loanAmount = loan.loanAmount;

        var loanDurationInYear = loan.tenor / 12;

        // full loan payment plan
        var paymentList = [];

        // calculate first period payment plan 
        var p1 = loan.piano(loanAmount, loanDurationInYear, loan.nominalInterestRate.toString().replace(",", "."), 12);
        var pianoUniversal = loan.pianoUniversal(loanAmount, loanDurationInYear, loan.nominalInterestRate.toString().replace(",", "."), 12);

        // second period plan  
        var p2 = [];
        var pianoUniversal2 = [];

        // full loan plan
        loan.p = [];
        loan.repaymentPlan = [];

        var p1FirstPayment = [];
        var p1LastPayment = [];
        var p2FirstPayment = [];
        var p2LastPayment = [];

        console.log("period 1");

        // Single Period loan 
        loan.secondMonthlyInstallment = '-';

        p1LastPayment = p1[p1.length - 1];
        p1FirstPayment = p1[0];

        // get the first period montly installment 
        if (loan.activeCurrency.currency == 'RSD') {
            loan.firstMonthlyInstallmentRsd = parseFloat(loan.getRata(p1FirstPayment));
        } else {
            loan.firstMonthlyInstallmentRsd = parseFloat(loan.getRata(p1FirstPayment)) * parseFloat(loan.middleExchangeRate.toString().replace(",", "."));
        }

        for (i = 0; i < p1.length; i++) {
            loan.p.push(p1[i]);
        }
        for (c = 0; c < pianoUniversal.length; c++) {
            loan.repaymentPlan.push(pianoUniversal[c]);
        }


    }

    /** 
     * Get the list of montlyInstallments for first and second 
     * Period 
     */
    this.getPaymentListByPlan = function() {
        loan.paymentsHistoryFirstPeriod = [];
        loan.paymentsHistoryWholePeriod = [];

        for (i = 0; i < loan.p.length; i++) {
            loan.paymentsHistoryWholePeriod.push(loan.getRata(loan.p[i]));
        }

        for (i = 0;
            (i < loan.p.length && i < loan.activeInterestType.firstPeriod.monthDuration); i++) {
            loan.paymentsHistoryFirstPeriod.push(loan.getRata(loan.p[i]));
        }
    }


    /**
     * Get the initial expenses of the loan 
     */

    this.getInitialExpenses = function(loanAmount, approvalCostPercentage, notaryCost, isWithMortgage) {

        var approvalCost = (loanAmount * approvalCostPercentage) / 100;

        if (approvalCost <= loan.min_approval_cost) {

            loan.approval_cost = loan.min_approval_cost;

        } else if (approvalCost >= loan.max_approval_cost) {

            loan.approval_cost = loan.max_approval_cost;

        } else {

            loan.approval_cost = approvalCost;

        }

        initialExpenses = loan.approval_cost;
        notaryCost = 1; // non ci sono notary cost
        return initialExpenses += ((isWithMortgage) ? notaryCost : 0);
    }

    /**
     * Update Periods
     *
     */
    this.updatePeriodLines = function() {

        var periodsNumber = loan.activeInterestType.periods;
        var onePeriodElements = $('[data-one-period]', loan.activeCalculator);
        var twoPeriodsElements = $('[data-two-periods]', loan.activeCalculator);

        // if 2 periods show double monthlyInstallment/InterestRate
        if (periodsNumber === 2 && loan.typeLoan != "mortgageLoan" && loan.typeLoan != "seniorCashLoan" && loan.typeLoan != "carLoan" &&  loan.typeLoan != "newCarLoan" && loan.typeLoan != "homeRecostruction" && loan.typeLoan != "consumerLoan" && loan.typeLoan != "energyEfficencyLoan" && loan.typeLoan != "carLoan" && loan.typeLoan != "refinanceLoan" && loan.typeLoan != "cashLoan") {

            onePeriodElements.addClass('hide');
            twoPeriodsElements.removeClass('hide');

        } else {

            twoPeriodsElements.addClass('hide');
            onePeriodElements.removeClass('hide');

        }

    };


    /**
     * Update Currency Select
     *
     */
    this.updateCurrencySelect = function() {

        var currencyOptions = loan.activeMortgage.glConfigurationList;
        var select = $('[data-algorithm-input="currency"]', loan.activeCalculator);
        var html = '';
        var countCurrency = 0;

        if (select.length > 0) {

            // clear select
            select.html('');

            // generate select html
            if(loan.typeLoan != 'carLoan' &&  loan.typeLoan != "newCarLoan"){
	            currencyOptions.forEach(function(currency) {
	
	                currency = currency.currency;
	
	                if (currency === loan.activeCurrency.currency) {
	                    html += '<option value="' + currency + '" selected>' + currency + '</option>';
	                } else {
	                    html += '<option value="' + currency + '">' + currency + '</option>';
	                }
	                countCurrency = countCurrency + 1;
	
	            });
            } else {
            	var listOfCurrency = [];
            	currencyOptions = loan.activeVariant.glProductVariantList;
            	$.each(currencyOptions, function(index, el){
            		listOfCurrency.push(el.glConfigurationList[0].currency);
            	});
            	// elimino i duplicati
            	listOfCurrency = listOfCurrency.sort().filter(function(item, pos, ary) {
                    return !pos || item != ary[pos - 1];
                });
            	for(count = 0; count < listOfCurrency.length; count++){
            		console.log("is equal " + listOfCurrency[count] == loan.activeCurrency.currency);
            		if(listOfCurrency[count] == loan.activeCurrency.currency){
                        html += '<option value="'+listOfCurrency[count]+'" selected>'+listOfCurrency[count]+'</option>';
            		} else {
                        html += '<option value="'+listOfCurrency[count]+'">'+listOfCurrency[count]+'</option>';
            		}
            		countCurrency = countCurrency + 1;
            	}
            }
            

            // append options
            select.append(html);
            if (countCurrency <= 1 && loan.typeLoan != 'carLoan' &&  loan.typeLoan != "newCarLoan") {
                $('[data-algorithm-input="currency"]', loan.activeCalculator).attr('disabled', true);
            }
            if(loan.typeLoan == 'carLoan' ||  loan.typeLoan == "newCarLoan"){
            	$('[data-algorithm-input="downPayment"]', loan.activeCalculator).parent().find('[data-algorithm-input="currency"]').prop("disabled", true);
			}
        }

    };


    /**
     * Update Mortgage Radio
     *
     */
    this.updateMortgageRadio = function() {

        var input = $('[data-algorithm-input="mortgage"]', loan.activeCalculator);
        var activeMortgage = loan.activeMortgage.variantType;

        // trigger click on default mortgage
        if (input.length && activeMortgage !== null) {

            $('input[value="' + activeMortgage + '"]', loan.activeCalculator).trigger('click');

        }

    };


    /**
     * Update Tenor Step
     * 
     *
     */
    this.updateTenorStep = function() {

        if (loan.activeVariant.productId == '10021' ||
            loan.activeVariant.productId == '10022' ||
            loan.activeVariant.productId == '10023' ||
            loan.activeVariant.productId == '16111' ||
            loan.activeVariant.productId == '16112' ||
            loan.activeVariant.productId == '16311' ||
            loan.activeVariant.productId == '17111' ||
            loan.activeVariant.productId == '17112' ||
            loan.activeVariant.productId == '17311' ||
            loan.activeVariant.productId == '30041' ||
            loan.activeVariant.productId == '30042' ||
            loan.activeVariant.productId == '30043' ||
            loan.activeVariant.productId == '20031' ||
            loan.activeVariant.productId == '20032' ||
            loan.activeVariant.productId == '20033' ||
            loan.activeVariant.productId == '40051' ||
            loan.activeVariant.productId == '40052' ||
            loan.activeVariant.productId == '40053' ||
            loan.activeVariant.productId == '40151' ||
            loan.activeVariant.productId == '40152' ||
            loan.activeVariant.productId == '40153') {
            var input = $('.rangeslider.rangeslider--2', loan.activeCalculator);
            var defaultTenor = $(".rangeslider.rangeslider--2").attr('data-value');
            console.log("valore default " + defaultTenor);
            var step = 1;
            input.attr('data-slider-step', step);

        } else if (loan.typeLoan != 'Universal Loan') {

            var input = $('.rangeslider.rangeslider--2', loan.activeCalculator);
            //logica cambio valore slider
            //console.log("set plus o min step value");
            var defaultTenor = $(".rangeslider.rangeslider--2").attr('data-value');
            console.log("valore default " + defaultTenor);

            if (loan.activeTab.data.amountList[1] != undefined && defaultTenor < loan.activeTab.data.amountList[1].minimumTenor) {
                var step = loan.activeTab.data.amountList[0].tenorScalingFactor;
                //console.log("sono nel primo step"+step);
                input.attr('data-slider-step', step);
            } else if (loan.activeTab.data.amountList[2] != undefined && defaultTenor >= loan.activeTab.data.amountList[0].maximumTenor && defaultTenor < loan.activeTab.data.amountList[2].minimumTenor) {
                var stepuno = loan.activeTab.data.amountList[1].tenorScalingFactor;
                //console.log("sono nel secondo step" +stepuno);
                input.attr('data-slider-step', stepuno);
            } else if (loan.activeTab.data.amountList[2] != undefined && defaultTenor > loan.activeTab.data.amountList[1].maximumTenor) {
                var stepdue = loan.activeTab.data.amountList[2].tenorScalingFactor;
                //console.log("sono nel terzo step"+stepdue);
                input.attr('data-slider-step', stepdue);
            } else if (loan.activeTab.data.amountList[2] == undefined && loan.activeTab.data.amountList[1] != undefined && defaultTenor == loan.activeTab.data.amountList[0].maximumTenor && loan.originalVal == 'add') {
                //qui ho solo 2 periodi vedi senior cash loan
                var stepuno = loan.activeTab.data.amountList[1].tenorScalingFactor;
                //console.log("sono nel secondo step" +stepuno);
                input.attr('data-slider-step', stepuno);
            } else if (loan.activeTab.data.amountList[2] == undefined && loan.activeTab.data.amountList[1] == undefined && defaultTenor == loan.activeTab.data.amountList[0].maximumTenor && loan.originalVal == 'add') {
                //qui ho solo 1 periodo vedi laki cash loan
                var stepuno = loan.activeTab.data.amountList[0].tenorScalingFactor;
                //console.log("sono nel secondo step" +stepuno);
                input.attr('data-slider-step', stepuno);
            } else if (loan.activeTab.data.amountList[2] == undefined && defaultTenor == loan.activeTab.data.amountList[0].maximumTenor && loan.originalVal == 'minus') {
                //qui ho solo 2 periodi vedi senior cash loan
                var stepuno = loan.activeTab.data.amountList[0].tenorScalingFactor;
                //console.log("sono nel secondo step" +stepuno);
                input.attr('data-slider-step', stepuno);
            }

            if (loan.activeTab.data.amountList[2] != undefined && defaultTenor == loan.activeTab.data.amountList[2].minimumTenor) {
                var stepuno = loan.activeTab.data.amountList[1].tenorScalingFactor;
                //console.log("sono nel secondo step" +stepuno);
                input.attr('data-slider-step', stepuno);
            } else if (loan.activeTab.data.amountList[2] != undefined && defaultTenor == loan.activeTab.data.amountList[1].maximumTenor) {
                var stepdue = loan.activeTab.data.amountList[2].tenorScalingFactor;
                //console.log("sono nel terzo step"+stepdue);
                input.attr('data-slider-step', stepdue);
            }

            if (loan.activeTab.data.amountList.length == 1) {
                var step = loan.activeTab.data.amountList[0].tenorScalingFactor;
                //console.log("sono nel primo step"+step);
                input.attr('data-slider-step', step);
            }

        } else {
            var input = $('.rangeslider.rangeslider--2', loan.activeCalculator);

            var defaultTenor = $(".rangeslider.rangeslider--2").attr('data-value');

            var inputSliderTre = $('.rangeslider.rangeslider--3', loan.activeCalculator);

            var defaultTenorTre = $(".rangeslider.rangeslider--3").attr('data-value');

            var inputSliderQuattro = $('.rangeslider.rangeslider--4', loan.activeCalculator);

            var defaultTenorQuattro = $(".rangeslider.rangeslider--4").attr('data-value');

            if (defaultTenor <= loan.activeInterestType.firstPeriod.monthDuration) {
                var step = loan.activeTab.data.amountList[0].tenorScalingFactor;
                input.attr('data-slider-step', step);
            }
            if (defaultTenorTre <= loan.activeInterestType.firstPeriod.monthDuration) {
                var step = loan.activeTab.data.amountList[0].tenorScalingFactor;
                inputSliderTre.attr('data-slider-step', step);
            }
            if (defaultTenorQuattro <= loan.activeInterestType.firstPeriod.monthDuration) {
                var step = loan.activeTab.data.amountList[0].tenorScalingFactor;
                inputSliderQuattro.attr('data-slider-step', step);
            }
        }
    };


    this.calculateStepIntermezzo = function() {
        var minCur = loan.activeTab.data.amountList[0].minimumTenor;
        var listSteps = [minCur];
        var indexesStep = [0];
        var tenorscaling = loan.activeTab.data.amountList[0].tenorScalingFactor;
        var maxCur = loan.activeTab.data.amountList[0].maximumTenor;
        var currentValue = minCur;
        var count = 0;
        for (var i = 0; currentValue < maxCur; i++) {
        	
        	currentValue = currentValue + tenorscaling;
        	if(currentValue >= maxCur){
        		currentValue = maxCur;
        	}
            count++;
            if(currentValue != 30){
                listSteps.push(currentValue);
            }
        }
        if (loan.activeInterestType.periods === 2) {
            minCur = loan.activeTab.data.amountList[1].minimumTenor;
            maxCur = loan.activeTab.data.amountList[1].maximumTenor;
            tenorscaling = loan.activeTab.data.amountList[1].tenorScalingFactor;
            currentValue = minCur;
            if (loan.activeVariant.productId == '10021' ||
                loan.activeVariant.productId == '10022' ||
                loan.activeVariant.productId == '10023' ||
                loan.activeVariant.productId == '30041' ||
                loan.activeVariant.productId == '30042' ||
                loan.activeVariant.productId == '30043' ||
                loan.activeVariant.productId == '20031' ||
                loan.activeVariant.productId == '20032' ||
                loan.activeVariant.productId == '20033' ||
                loan.activeVariant.productId == '40051' ||
                loan.activeVariant.productId == '40052' ||
                loan.activeVariant.productId == '40053'){
                    listSteps.push(currentValue);
                }
            for (var i = 0; currentValue < maxCur; i++) {
            	
            	currentValue = currentValue + tenorscaling;
            	if(currentValue >= maxCur){
            		currentValue = maxCur;
            	}
                count++;
                listSteps.push(currentValue);
            }
        }
        if (loan.activeInterestType.periods === 3) {
            minCur = loan.activeTab.data.amountList[1].minimumTenor;
            maxCur = loan.activeTab.data.amountList[1].maximumTenor;
            tenorscaling = loan.activeTab.data.amountList[1].tenorScalingFactor;
            currentValue = minCur;
            if (loan.activeVariant.productId == '10021' ||
                loan.activeVariant.productId == '10022' ||
                loan.activeVariant.productId == '10023' ||
                loan.activeVariant.productId == '30041' ||
                loan.activeVariant.productId == '30042' ||
                loan.activeVariant.productId == '30043' ||
                loan.activeVariant.productId == '20031' ||
                loan.activeVariant.productId == '20032' ||
                loan.activeVariant.productId == '20033' ||
                loan.activeVariant.productId == '40051' ||
                loan.activeVariant.productId == '40052' ||
                loan.activeVariant.productId == '40053'){
                    listSteps.push(currentValue);
                }
            for (var i = 0; currentValue < maxCur; i++) {
            	
            	currentValue = currentValue + tenorscaling;
            	if(currentValue >= maxCur){
            		currentValue = maxCur;
            	}
                count++;
                listSteps.push(currentValue);
            }
            minCur = loan.activeTab.data.amountList[2].minimumTenor;
            maxCur = loan.activeTab.data.amountList[2].maximumTenor;
            tenorscaling = loan.activeTab.data.amountList[2].tenorScalingFactor;
            currentValue = minCur;
            if (loan.activeVariant.productId == '10021' ||
                loan.activeVariant.productId == '10022' ||
                loan.activeVariant.productId == '10023' ||
                loan.activeVariant.productId == '30041' ||
                loan.activeVariant.productId == '30042' ||
                loan.activeVariant.productId == '30043' ||
                loan.activeVariant.productId == '20031' ||
                loan.activeVariant.productId == '20032' ||
                loan.activeVariant.productId == '20033' ||
                loan.activeVariant.productId == '40051' ||
                loan.activeVariant.productId == '40052' ||
                loan.activeVariant.productId == '40053'){
                    listSteps.push(currentValue);
                }
            for (var i = 0; currentValue < maxCur; i++) {
            	
            	currentValue = currentValue + tenorscaling;
            	if(currentValue >= maxCur){
            		currentValue = maxCur;
            	}
                count++;
                listSteps.push(currentValue);
            }
        }
        loan.stepTenor = listSteps;
    }

    this.findIndexByTenor = function(tenor) { return loan.stepTenor.indexOf(tenor); }
    this.findTenorByIndex = function(index) { return loan.stepTenor[index]; }

    /**
     * Update Tenor Slider
     *
     */
    this.updateTenorSlider = function() {

        if (loan.activeVariant.productId == '10021' ||
            loan.activeVariant.productId == '10022' ||
            loan.activeVariant.productId == '10023' ||
            loan.activeVariant.productId == '16111' ||
            loan.activeVariant.productId == '16112' ||
            loan.activeVariant.productId == '16311' ||
            loan.activeVariant.productId == '17111' ||
            loan.activeVariant.productId == '17112' ||
            loan.activeVariant.productId == '17311' ||
            loan.activeVariant.productId == '30041' ||
            loan.activeVariant.productId == '30042' ||
            loan.activeVariant.productId == '30043' ||
            loan.activeVariant.productId == '20031' ||
            loan.activeVariant.productId == '20032' ||
            loan.activeVariant.productId == '20033' ||
            loan.activeVariant.productId == '40051' ||
            loan.activeVariant.productId == '40052' ||
            loan.activeVariant.productId == '40053' ||
            loan.activeVariant.productId == '40151' ||
            loan.activeVariant.productId == '40152' ||
            loan.activeVariant.productId == '40153') {
            var input = $('.rangeslider.rangeslider--2', loan.activeCalculator);
            if (input.length) {
                this.calculateStepIntermezzo();
                var index = parseInt(input.attr('data-slider-index'));
                var slider = window.sliderbootstrap[index];
                var wrapper = input.parents('.sliderRange__wrapper');

                // set minimum 
                var tenorMin = loan.findTenorByIndex(0);
                var tenorDefault = undefined;
                var tenorValue = input.attr('value');

                if (loan.checkCarLoanAndAmountThreshold()) {
                    input.attr('data-slider-min', 3);
                    wrapper.find('[data-min-tenor]').html(loan.findTenorByIndex(3));
                    if (loan.findTenorByIndex(tenorValue) > loan.activeTab.data.amountList[1].defaultTenor) {
                        tenorDefault = loan.activeTab.data.amountList[1].defaultTenor;
                    } else {
                        tenorDefault = loan.findTenorByIndex(tenorValue);
                    }
                } else {
                    input.attr('data-slider-min', 0);
                    wrapper.find('[data-min-tenor]').html(loan.findTenorByIndex(0));
                    if (loan.findTenorByIndex(tenorValue) != undefined) {
                        tenorDefault = loan.findTenorByIndex(tenorValue);
                    } else {
                        tenorDefault = loan.activeTab.data.amountList[0].defaultTenor;
                    }
                }

                //set maximum
                var tenorMax = loan.findTenorByIndex(loan.stepTenor.length - 1);
                //tenorMax=loan.activeInterestType.secondPeriod ? loan.activeInterestType.secondPeriod.monthDuration : loan.activeTab.data.amountList[0].maximumTenor;
                input.attr('data-slider-max', loan.stepTenor.length - 1);
                wrapper.find('[data-max-tenor]').html(loan.findTenorByIndex(loan.stepTenor.length - 1));

                // rebuild slider 
                slider.slider('destroy');
                slider.slider({ tooltip: 'show' });
                input.attr('data-slider-value', loan.findIndexByTenor(tenorDefault));
                wrapper.find('.qty').val(loan.findIndexByTenor(tenorDefault));
                wrapper.find('.valShow').html(loan.findIndexByTenor(tenorDefault));
                slider.slider('setValue', loan.findIndexByTenor(tenorDefault), true);
            }
        } else if (loan.typeLoan != 'Universal Loan') {

            var input = $('.rangeslider.rangeslider--2', loan.activeCalculator);

            if (input.length) {

                var index = parseInt(input.attr('data-slider-index'));
                var slider = window.sliderbootstrap[index];
                var wrapper = input.parents('.sliderRange__wrapper');
                // set minimum
                var tenorMin = loan.activeTab.data.amountList[0].minimumTenor; //loan.activeInterestType.firstPeriod.monthMinimum ? loan.activeInterestType.firstPeriod.monthMinimum : loan.activeTab.data.amountList[0].minimumTenor;
                if (loan.tenorUnit === 'YEARS') tenorMin = tenorMin / 12;
                input.attr('data-slider-min', tenorMin);
                wrapper.find('[data-min-tenor]').html(tenorMin);

                // set maximum
                var tenorMax = loan.activeInterestType.secondPeriod ? loan.activeInterestType.secondPeriod.monthDuration : loan.activeTab.data.amountList[0].maximumTenor;

                //se ho 2 periodi prendo il tenormax dal 2
                if (loan.activeInterestType.periods === 2 && tenorMax <= loan.activeInterestType.secondPeriod.monthDuration) {
                    tenorMax = loan.activeInterestType.secondPeriod.monthDuration;
                }

                //if ho 3 periodi prendo il tenormax dal 3
                if (loan.activeInterestType.periods === 3 && tenorMax <= loan.activeInterestType.thirdPeriod.monthDuration) {
                    tenorMax = loan.activeInterestType.thirdPeriod.monthDuration;
                }


                if (loan.tenorUnit === 'YEARS') tenorMax = tenorMax / 12;
                input.attr('data-slider-max', tenorMax);
                wrapper.find('[data-max-tenor]').html(tenorMax);

                // rebuild slider
                slider.slider('destroy');
                slider.slider({ tooltip: 'show' });

                var tenorDefault = loan.activeInterestType.firstPeriod.monthMinimum ? loan.activeInterestType.firstPeriod.monthMinimum : loan.activeTab.data.amountList[0].defaultTenor;
                if (loan.tenor != null && loan.tenor != undefined && loan.tenor != 0) {
                    tenorDefault = loan.tenor;
                }
                if (loan.activeInterestType.periods == 1 && tenorDefault <= tenorMin) {
                    tenorDefault = loan.activeTab.data.amountList[0].defaultTenor;
                }
                if (loan.activeInterestType.periods === 2 && tenorDefault <= tenorMin) {
                    tenorDefault = tenorMin;
                }
                if (loan.changedActiveTab) {
                    // tenorDefault = tenorMin;
                }
                if (tenorDefault > tenorMax) {
                    tenorDefault = tenorMax;
                }
                if (tenorDefault < tenorMin) {
                    tenorDefault = tenorMin;
                }
                if (loan.tenorUnit === 'YEARS') tenorDefault = tenorDefault / 12;
                input.attr('data-slider-value', tenorDefault);
                wrapper.find('.qty').val(tenorDefault);
                wrapper.find('.valShow').html(tenorDefault);
                slider.slider('setValue', tenorDefault, true);


                // attach slide event
                //                slider.on('slide', function() {
                //                    var value = slider.slider('getValue');
                //                    wrapper.find('.qty').val(value);
                //                    input.siblings('.qty').trigger('change');
                //                });

            }
        } else {

            var input = $('.rangeslider.rangeslider--2', loan.activeCalculator);
            var inputSliderTre = $('.rangeslider.rangeslider--3', loan.activeCalculator);
            var inputSliderQuattro = $('.rangeslider.rangeslider--4', loan.activeCalculator);

            if (input.length && inputSliderTre.length && inputSliderQuattro.length) {

                var index = parseInt(input.attr('data-slider-index'));
                var indexSliderTre = parseInt(inputSliderTre.attr('data-slider-index'));
                var indexSliderQuattro = parseInt(inputSliderQuattro.attr('data-slider-index'));

                var slider = window.sliderbootstrap[index];
                var sliderTre = window.sliderbootstrap[indexSliderTre];
                var sliderQuattro = window.sliderbootstrap[indexSliderQuattro];

                var wrapper = input.parents('.sliderRange__wrapper');
                var wrapperTre = inputSliderTre.parents('.sliderRange__wrapper');
                var wrapperQuattro = inputSliderQuattro.parents('.sliderRange__wrapper');

                // set minimum
                var tenorMin = loan.activeTab.data.amountList[0].minimumTenor; //loan.activeInterestType.firstPeriod.monthMinimum ? loan.activeInterestType.firstPeriod.monthMinimum : loan.activeTab.data.amountList[0].minimumTenor;

                if (loan.tenorUnit === 'YEARS') tenorMin = tenorMin / 12;
                input.attr('data-slider-min', tenorMin);
                wrapper.find('[data-min-tenor]').html(tenorMin);
                inputSliderTre.attr('data-slider-min', tenorMin);
                wrapperTre.find('[data-min-tenor]').html(tenorMin);
                inputSliderQuattro.attr('data-slider-min', tenorMin);
                wrapperQuattro.find('[data-min-tenor]').html(tenorMin);

                // set maximum
                var tenorMax = loan.activeInterestType.secondPeriod ? loan.activeInterestType.secondPeriod.monthDuration : loan.activeTab.data.amountList[0].maximumTenor;
                //se ho 2 periodi prendo il tenormax dal 2
                if (loan.activeInterestType.periods === 2 && tenorMax <= loan.activeInterestType.secondPeriod.monthDuration) {
                    tenorMax = loan.activeInterestType.secondPeriod.monthDuration;
                }
                //if ho 3 periodi prendo il tenormax dal 3
                if (loan.activeInterestType.periods === 3 && tenorMax <= loan.activeInterestType.thirdPeriod.monthDuration) {
                    tenorMax = loan.activeInterestType.thirdPeriod.monthDuration;
                }

                var tenorDefault = loan.activeInterestType.firstPeriod.monthMinimum ? loan.activeInterestType.firstPeriod.monthMinimum : loan.activeTab.data.amountList[0].defaultTenor;
                if (loan.activeInterestType.periods === 2 && tenorDefault <= tenorMin) {
                    tenorDefault = tenorMin;
                }


                if (loan.tenorUnit === 'YEARS') tenorMax = tenorMax / 12;
                input.attr('data-slider-max', tenorMax);
                wrapper.find('[data-max-tenor]').html(tenorMax);
                inputSliderTre.attr('data-slider-max', tenorMax);
                wrapperTre.find('[data-max-tenor]').html(tenorMax);
                inputSliderQuattro.attr('data-slider-max', tenorMax);
                wrapperQuattro.find('[data-max-tenor]').html(tenorMax);

                // rebuild slider
                slider.slider('destroy');
                slider.slider({ tooltip: 'show' });

                sliderTre.slider('destroy');
                sliderTre.slider({ tooltip: 'show' });

                sliderQuattro.slider('destroy');
                sliderQuattro.slider({ tooltip: 'show' });

                if (loan.tenorUnit === 'YEARS') tenorDefault = tenorDefault / 12;
                input.attr('data-slider-value', tenorDefault);
                wrapper.find('.qty').val(tenorDefault);
                wrapper.find('.valShow').html(tenorDefault);
                inputSliderTre.attr('data-slider-value', tenorDefault);
                wrapperTre.find('.qty').val(tenorDefault);
                wrapperTre.find('.valShow').html(tenorDefault);
                inputSliderQuattro.attr('data-slider-value', tenorDefault);
                wrapperQuattro.find('.qty').val(tenorDefault);
                wrapperQuattro.find('.valShow').html(tenorDefault);


                slider.slider('setValue', tenorDefault, true);
                sliderTre.slider('setValue', tenorDefault, true);
                sliderQuattro.slider('setValue', tenorDefault, true);

                // attach slide event
                slider.on('slide', function() {
                    var value = slider.slider('getValue');
                    wrapper.find('.qty').val(value);
                    wrapper.find('.valShow').html(value);
                    input.siblings('.qty').trigger('change');
                    inputSliderTre.attr('data-slider-max', slider.slider('getValue'));
                    wrapperTre.find('[data-max-tenor]').html(slider.slider('getValue'));
                    inputSliderQuattro.attr('data-slider-max', slider.slider('getValue'));
                    wrapperQuattro.find('[data-max-tenor]').html(slider.slider('getValue'));
                    sliderTre.slider('destroy');
                    sliderTre.slider({ tooltip: 'show' });

                    sliderQuattro.slider('destroy');
                    sliderQuattro.slider({ tooltip: 'show' });

                    sliderTre.slider('setValue', sliderTre.slider('getValue'), true);
                    sliderQuattro.slider('setValue', sliderQuattro.slider('getValue'), true);

                    if (parseInt(sliderTre.slider('getValue')) > parseInt(slider.slider('getValue'))) {
                        sliderTre.slider('setValue', slider.slider('getValue'), true);
                    } else {
                        sliderTre.slider('setValue', sliderTre.slider('getValue'), true);
                    }


                    if (parseInt(sliderQuattro.slider('getValue')) > parseInt(slider.slider('getValue'))) {
                        sliderQuattro.slider('setValue', slider.slider('getValue'), true);
                    } else {
                        sliderQuattro.slider('setValue', sliderQuattro.slider('getValue'), true);
                    }
                    wrapperTre.find('.qty').val(sliderTre.slider('getValue'));
                    wrapperTre.find('.valShow').html(sliderTre.slider('getValue'));
                    wrapperQuattro.find('.qty').val(sliderQuattro.slider('getValue'));
                    wrapperQuattro.find('.valShow').html(sliderQuattro.slider('getValue'));
                });
                sliderTre.on('slide', function() {
                    var value = sliderTre.slider('getValue');
                    wrapperTre.find('.qty').val(value);
                    wrapper.find('.valShow').html(value);
                    inputSliderTre.siblings('.qty').trigger('change');
                });
                sliderQuattro.on('slide', function() {
                    var value = sliderQuattro.slider('getValue');
                    wrapperQuattro.find('.qty').val(value);
                    wrapper.find('.valShow').html(value);
                    inputSliderQuattro.siblings('.qty').trigger('change');
                });

            }



        }

    };
    
    
    /**
     * Update Slider Maintaining value
     *
     */
    this.updateTenorMaintainStepSlider = function() {

        var input = $('.rangeslider.rangeslider--2', loan.activeCalculator);
        if (input.length) {
            this.calculateStepIntermezzo();
            var index = parseInt(input.attr('data-slider-index'));
            var slider = window.sliderbootstrap[index];
            var wrapper = input.parents('.sliderRange__wrapper');

            // set minimum 
            var tenorMin = loan.findTenorByIndex(0);
            input.attr('data-slider-min', 0);
            wrapper.find('[data-min-tenor]').html(loan.findTenorByIndex(0));
            //set maximum

            var tenorMax = loan.findTenorByIndex(loan.stepTenor.length - 1);
            //tenorMax=loan.activeInterestType.secondPeriod ? loan.activeInterestType.secondPeriod.monthDuration : loan.activeTab.data.amountList[0].maximumTenor;
            input.attr('data-slider-max', loan.stepTenor.length - 1);
            wrapper.find('[data-max-tenor]').html(loan.findTenorByIndex(loan.stepTenor.length - 1));

            // rebuild slider 
            var tenorDefault = loan.tenor;
            var indexTenor = loan.findIndexByTenor(tenorDefault);
            if(indexTenor < 0 ){
            	slider.slider('destroy');
                slider.slider({ tooltip: 'show' });
                var tenorDefault2 = loan.activeTab.data.amountList[0].defaultTenor;
                input.attr('data-slider-value', loan.findIndexByTenor(tenorDefault2));
                wrapper.find('.qty').val(loan.findIndexByTenor(tenorDefault2));
                wrapper.find('.valShow').html(loan.findIndexByTenor(tenorDefault2));
                slider.slider('setValue', loan.findIndexByTenor(tenorDefault2), true);
            }
            else{
            	slider.slider('destroy');
                slider.slider({ tooltip: 'show' });
                input.attr('data-slider-value', loan.findIndexByTenor(tenorDefault));
                wrapper.find('.qty').val(loan.findIndexByTenor(tenorDefault));
                wrapper.find('.valShow').html(loan.findIndexByTenor(tenorDefault));
                slider.slider('setValue', loan.findIndexByTenor(tenorDefault), true);
            }
        }

    };
    
    


    /**
     * Update Interest Type Select
     *
     */
    this.updateInterestTypeSelect = function() {

        var interestTypes = loan.activeTab.data.interest;
        var select = $('[data-interest-select]', loan.activeCalculator);
        var html = '';

        if (select.length) {

            // clear select
            select.html('');

            /* generate select html
             interestTypes.forEach( function( interestType ) {
 
                 var code = interestType.interestCode;
                 var label = calculatorLabels[code];
 
                 if( code === loan.activeInterestType.interestCode ) {
                     html += '<option value="' + code + '" selected>' + label + '</option>';
                 } else {
                     html += '<option value="' + code + '">' + label + '</option>';
                 }
 
             } );
             */
            var checkInterestType = "";
            var countInterestType = 0;
            var ind = 0;
            loan.activeVariant.glProductVariantList.forEach(function(variant) {

                code = variant.variantType;
                var label = calculatorLabels[code];
                if (!checkInterestType.includes(label)) {
                    if (code === loan.activeMortgage.variantType) {
                        html += '<option value="' + code + '" selected>' + label + '</option>';
                    } else {
                        html += '<option value="' + code + '">' + label + '</option>';
                    }
                    
    				$("div[data-algorithm-input=newInterest]", loan.activeCalculator).children().find("input[type=radio]").each(function(index, element){
    					console.log("index");
    					if(index == ind){
    						$(element).val(code);
    						$(element).parent().find("span").text(label);
    						if (!($(".otherLoanContainer").length > 0)) {
    							$(element).parents(".section__form__inline").css("display", "inline-block");
					        }
    						ind = ind + 1;
    						return false;
    					}					
    				});
                    checkInterestType = checkInterestType.concat(label + ",");
                    countInterestType++;
                }
            });
            if (countInterestType == 1) {
                $('[data-interest-select]', loan.activeCalculator).hide();
                $('[data-interest-row]', loan.activeCalculator).hide();
                $("div[data-algorithm-input=newInterest]", loan.activeCalculator).hide();
                $("[data-fixed-interest-title]", loan.activeCalculator).html("<p>"+$("[data-fixed-interest-title]", loan.activeCalculator).text() + "</p>");
				$("[data-fixed-interest-title]", loan.activeCalculator).removeClass("block__title");
            }

            // append option HTML
            select.append(html);

        }

    };

    /**
     * Update Share Calculator Link
     *
     */
    this.updateShareCalculatorLink = function() {

        // get url without query string
        var currentURL = window.location.href;
        currentURL = currentURL.split('?');
        currentURL = currentURL[0];

        // add standard query params
        //console.log(loan);
        var queryParams = '?loanAmount=' + loan['loanAmount'] + '&tenor=' + loan['tenor'] + '&currency=' + loan['currency'] + '&interestRateType=' + loan['interestRateType'] + '&mortgage=' + loan['mortgage']; // + loanpurposeurl;
        console.log(queryParams);
        // without salary case
        var isWithoutSalaryTab = $('[data-tab="without-salary"]').hasClass('open');
        if (isWithoutSalaryTab) queryParams += '&isDefault=false';

        //custom url for data-socialshare
        if ($('[data-socialshare]').length > 0) {

            $('[data-socialshare]').each(function() {

                //if we are on the homepage, get the clean url when it's shared from the sidebar
                if ($("html").hasClass("home")) {

                    if (!$(this).parents('.socialShare__calculator').length > 0) {
                        queryParams = "";
                    }

                }

                //get the url from the attribute
                // console.log(1);
                if ($(this).attr("data-share-url").length > 0) {
                    // console.log(2);
                    if ($(this).attr("data-share-url") !== "") {
                        // console.log(3);
                        currentURL = $(this).attr("data-share-url");
                    }
                }

                if ($(this).attr("data-socialshare") == "facebook") {

                    $(this).attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + currentURL + queryParams);

                }

                if ($(this).attr("data-socialshare") == "twitter") {

                    $(this).attr("href", "https://twitter.com/home?status=" + currentURL + queryParams);

                }

                if ($(this).attr("data-socialshare") == "linkedin") {

                    $(this).attr("href", "https://www.linkedin.com/sharing/share-offsite/?url=" + currentURL + queryParams);

                }

                if ($(this).attr("data-socialshare") == "whatsapp") {

                    $(this).attr("href", " https://wa.me/?text=" + encodeURIComponent(currentURL) + encodeURIComponent(queryParams));

                }

                if ($(this).attr("data-socialshare") == "mail") {

                    $(this).attr("href", "mailto:?body=" + currentURL + encodeURIComponent(queryParams));

                }

            });
        }

    };


    /**
     * init Loan Amount Input
     *
     */
    this.initLoanAmountInput = function() {

        var input = $('[data-algorithm-input="loanAmount"]', loan.activeCalculator);

        if (input.length) {

            var minimumAmount = loan.activeTab.data.minimumAmount;
            var maximumAmount = loan.activeTab.data.maxAmountForOnline;
            var defaultAmount = loan.activeTab.data.defaultAmount;
            if (loan.typeLoan == 'Universal Loan') {
                maximumAmount = Number.MAX_VALUE;
                minimumAmount = 0;
                console.log("set max value universal " + maximumAmount);
            } else if (loan.typeLoan == 'mortgageLoan') {
                maximumAmount = round(loan.activeTab.data.maxAmountForOnline / 0.8, 0);
                minimumAmount = round(loan.activeTab.data.minimumAmount / 0.8, 0);
            } else if (loan.typeLoan == 'carLoan' ||  loan.typeLoan == "newCarLoan") {
                maximumAmount = round(loan.activeTab.data.maxAmountForOnline, 0);
                minimumAmount = round(loan.activeTab.data.minimumAmount, 0);
            }
            // update minimum
            input.attr('data-parsley-min', minimumAmount);
            var min = number_format(minimumAmount, 2, genericSettings.decimal, genericSettings.separator);
            $('[data-loan-min]',  loan.activeCalculator).text(min);

            // update maximum
            input.attr('data-parsley-max', maximumAmount);
            var max = number_format(maximumAmount, 2, genericSettings.decimal, genericSettings.separator);
            $('[data-loan-max]',  loan.activeCalculator).text(max);

            // insert default value if the value is 0
            if ((input.val() == "0" || parseInt(input.val()) < defaultAmount) || parseInt(input.val()) >  maximumAmount) {

                input.val(defaultAmount);

            }

            // validate
            input.parsley().validate();

        }

    };

    /**
     * Update Loan Amount Input
     *
     */
    this.updateLoanAmountInput = function() {

        var input = $('[data-algorithm-input="loanAmount"]', loan.activeCalculator);

        if (input.length) {

            var defaultAmount = loan.activeTab.data.defaultAmount;

            // insert default value if the value is 0
            loan.loanAmount = defaultAmount;
            // validate
            input.parsley().validate();

        }

    };
    
    
    /**
     * update max min Loan Amount Input
     *
     */
    this.updateMaxMinLoanAmount = function() {

        var input = $('[data-algorithm-input="loanAmount"]', loan.activeCalculator);

        if (input.length) {

            var minimumAmount = loan.activeTab.data.minimumAmount;
            var maximumAmount = loan.activeTab.data.maxAmountForOnline;
            var defaultAmount = loan.activeTab.data.defaultAmount;
            if (loan.typeLoan == 'Universal Loan') {
                maximumAmount = Number.MAX_VALUE;
                minimumAmount = 0;
                console.log("set max value universal " + maximumAmount);
            } else if (loan.typeLoan == 'mortgageLoan') {
                maximumAmount = round(loan.activeTab.data.maxAmountForOnline / 0.8, 0);
                minimumAmount = round(loan.activeTab.data.minimumAmount / 0.8, 0);
            } else if (loan.typeLoan == 'carLoan' ||  loan.typeLoan == "newCarLoan") {
                maximumAmount = round(loan.activeTab.data.maxAmountForOnline, 0);
                minimumAmount = round(loan.activeTab.data.minimumAmount, 0);
            }
            // update minimum
            input.attr('data-parsley-min', minimumAmount);
            var min = number_format(minimumAmount, 2, genericSettings.decimal, genericSettings.separator);
            $('[data-loan-min]',  loan.activeCalculator).text(min);

            // update maximum
            input.attr('data-parsley-max', maximumAmount);
            var max = number_format(maximumAmount, 2, genericSettings.decimal, genericSettings.separator);
            $('[data-loan-max]',  loan.activeCalculator).text(max);

            // validate
            input.parsley().validate();

        }

    };
    


    /**
     * Toggle Down Payment Output Line
     *
     */
    this.toggleDownPaymentInputLine = function(isEur) {

        var downPaymentOutputLine = $('div[data-show-input-group]', loan.activeCalculator);
        if ($('[data-algorithm-input="downPaymentPercentuage"]', loan.activeCalculator).val()) {
            loan.downPaymentPercentage = loan.downPaymentPercentageMortgage;
        }
        if ($('[data-algorithm-input="loanAmount"]', loan.activeCalculator).length > 0 && $('[data-algorithm-input="downPayment"]', loan.activeCalculator).length > 0) {

            if (isEur) {
              //loanAmount = parseInt($('[data-algorithm-input="loanAmount"]', loan.activeCalculator).val().replaceAll(".", "").replaceAll(/\s/g, ''));
                loanAmount = parseInt($('[data-algorithm-input="loanAmount"]', loan.activeCalculator).val().split('.').join('').split(/\s/g).join(''));
                var downPaymentInput = $('[data-algorithm-input="downPayment"]', loan.activeCalculator);
                loan["downPayment"] = 0;
                loan.downPayment = round(loanAmount * loan.downPaymentPercentage / 100, 0);
                downPaymentInput.val(round(loan.downPayment, 0)); // elimino le cifre decimali perchè altrimenti l'input mostra valori errati
                downPaymentInput.attr('data-parsley-min', loan.downPayment);
                downPaymentInput.attr('data-parsley-max', loanAmount);
                downPaymentOutputLine.removeClass('hide');

            } else {
                loan["downPayment"] = 0;
                loan.downPayment = 0;
                var downPaymentInput = $('[data-algorithm-input="downPayment"]', loan.activeCalculator);
                downPaymentInput.val(loan.downPayment);
                downPaymentInput.attr('data-parsley-min', 0);
                downPaymentInput.attr('data-parsley-max', 0);
                downPaymentOutputLine.addClass('hide');

            }
        }

    };


    /**
     * Set Active Variant
     *
     */
    this.setActiveVariant = function() {

        if (loan.activeCalculator) {

            var calculatorData = loan.activeCalculator.siblings('.calculatorData').val();

            try {

                // get calculator data
                var variantData = JSON.parse(calculatorData);
                loan.activeVariant = variantData.glGenericSimulatorParams;

            } catch (e) {

                console.error('Calculator JSON file invalid');

            }

        }

    };

    this.setActiveVariantUpperMass = function() {

        if (loan.activeCalculator) {

            var calculatorData = loan.activeCalculator.siblings('.calculatorDataUpperMass').val();

            try {

                // get calculator data
                var variantData = JSON.parse(calculatorData);
                loan.activeVariant = variantData.glGenericSimulatorParams;

            } catch (e) {

                console.error('Calculator JSON file invalid');

            }

        }

    };


    /**
     * Set Active Mortgage
     *
     */
    this.updateCalculatorConfigurationByTenor = function(currentTenor, interestCode) {

        var variantList = loan.activeVariant.glProductVariantList;
        var variantType = "";
        var v;
        // cicle all the martgage options
        var foundInterest = false;
        var previousActiveTab = JSON.stringify(loan.activeTab).toString();
        // cerco in un altra variante un tasso di interesse nel range del tenor

        for (k = 0;
            (k < loan.activeCurrency.glGenericCalculationList.length || foundInterest); k++) {

            var c = loan.activeCurrency.glGenericCalculationList[k];
            //console.log("genericCalculationList " + JSON.stringify(c));
            var percentuageDownPayment = $('[data-algorithm-input="downPaymentPercentuage"]', loan.activeCalculator).val();
            //verifico se è presente il downpayment nel caso mortgage
            if (percentuageDownPayment) {
                if (c.amountList[0].minimumTenor <= currentTenor && c.interest[0].firstPeriod.monthDuration >= currentTenor && c.amountList[0].maximumTenor >= currentTenor && loan.activeTab.data.standard == c.standard) {
                    //verifico se il valore del downpayment è 30% o no
                    if (!loan.downPaymentPercentuageUnder30) {
                        //caso 20% fisso
                        if (c["downPayment"] == '20' && loan.downpaymentPercentuageFix20) {
                            loan.activeTab = {
                                'isDefault': c.isDefault,
                                'data': c,
                            };
                            foundInterest = true;
                            if (previousActiveTab != JSON.stringify(loan.activeTab).toString()) {
                                loan.setActiveInterestType(interestCode);
                                loan.updateTenorUnit();
                                loan.updateTenorSlider();
                                loan.updateTenorStep();
                            }
                            loan.changedActiveTab = true;
                            break;
                        }
                        //caso 20% - 29% (less than 30)
                        else if (c["downPayment"] == '20') {
                            loan.activeTab = {
                                'isDefault': c.isDefault,
                                'data': c,
                            };
                            foundInterest = true;
                            if (previousActiveTab != JSON.stringify(loan.activeTab).toString()) {
                                loan.setActiveInterestType(interestCode);
                                loan.updateTenorUnit();
                                loan.updateTenorSlider();
                                loan.updateTenorStep();
                            }
                            loan.changedActiveTab = true;
                            break;
                        }
                        //caso without deposit (w/o deposit)
                        else if (c["downPayment"] == 'null') {
                            loan.activeTab = {
                                'isDefault': c.isDefault,
                                'data': c,
                            };
                            foundInterest = true;
                            if (previousActiveTab != JSON.stringify(loan.activeTab).toString()) {
                                loan.setActiveInterestType(interestCode);
                                loan.updateTenorUnit();
                                loan.updateTenorSlider();
                                loan.updateTenorStep();
                            }
                            loan.changedActiveTab = true;
                            break;
                        }
                    }
                    //caso del 30%
                    else {
                        if (c["downPayment"] == '30') {
                            loan.activeTab = {
                                'isDefault': c.isDefault,
                                'data': c,
                            };
                            foundInterest = true;
                            if (previousActiveTab != JSON.stringify(loan.activeTab).toString()) {
                                loan.setActiveInterestType(interestCode);
                                loan.updateTenorUnit();
                                loan.updateTenorSlider();
                                loan.updateTenorStep();
                            }
                            loan.changedActiveTab = true;
                            break;
                        }

                    }
                }
            } else {

			if(loan.activeVariant.productId == '10021' ||
	            loan.activeVariant.productId == '10022' ||
	            loan.activeVariant.productId == '10023' ||
	            loan.activeVariant.productId == '16111' ||
	            loan.activeVariant.productId == '16112' ||
	            loan.activeVariant.productId == '16311' ||
	            loan.activeVariant.productId == '17111' ||
                loan.activeVariant.productId == '17112' ||
                loan.activeVariant.productId == '17311' ||
	            loan.activeVariant.productId == '30041' ||
	            loan.activeVariant.productId == '30042' ||
	            loan.activeVariant.productId == '30043' ||
	            loan.activeVariant.productId == '20031' ||
	            loan.activeVariant.productId == '20032' ||
	            loan.activeVariant.productId == '20033' ||
	            loan.activeVariant.productId == '40051' ||
	            loan.activeVariant.productId == '40052' ||
	            loan.activeVariant.productId == '40053' ||
                loan.activeVariant.productId == '40151' ||
                loan.activeVariant.productId == '40152' ||
                loan.activeVariant.productId == '40153') {
	            	currentTenor = loan.findTenorByIndex(currentTenor);
	            }
                if (c.amountList[0].minimumTenor <= currentTenor && c.interest[0].firstPeriod.monthDuration >= currentTenor && c.amountList[0].maximumTenor >= currentTenor && loan.activeTab.data.standard == c.standard) {

                    loan.activeTab = {
                        'isDefault': c.isDefault,
                        'data': c,
                    };
                    foundInterest = true;
                    if (previousActiveTab != JSON.stringify(loan.activeTab).toString()) {
                        loan.setActiveInterestType(interestCode);
                        loan.updateTenorUnit();
                        loan.updateTenorSlider();
                        loan.updateTenorStep();
                    }
                    loan.changedActiveTab = true;
                    break;

                }
            }
        }

        if (!foundInterest) {
            // se non trovo il tasso di interesse nel range assegno quello di default della variante e aggiorno il tenor	

            for (k = 0;
                (k < loan.activeCurrency.glGenericCalculationList.length || foundInterest); k++) {

                var c = loan.activeCurrency.glGenericCalculationList[k];

                if (c.isDefault) {

                    loan.activeTab = {
                        'isDefault': c.isDefault,
                        'data': c,
                    };
                    foundInterest = true;
                    loan.changedActiveTab = true;
                    break;

                }

            }
            loan.setActiveInterestType(interestCode);
            loan.updateTenorUnit();
            loan.updateTenorSlider();
            loan.updateTenorStep();

        }

        loan['mortgage'] = variantType;

    };

    /**
     * Set Active Mortgage
     *
     */
    this.setActiveMortgage = function(value) {

        var mortgageOptions = loan.activeVariant.glProductVariantList;
        var numberOfMortgage = mortgageOptions.length;

        // cicle all the martgage options
        for (var i = 0; i < numberOfMortgage; i++) {
            if (value == "EUR" || value == "RSD") {
                if (mortgageOptions[i].variantId == 1 && loan.activeMortgage.variantId == 2) {
                    loan.activeMortgage = mortgageOptions[i];
                    break;
                } else if (mortgageOptions[i].variantId == 2 && loan.activeMortgage.variantId == 1) {
                    loan.activeMortgage = mortgageOptions[i];
                    break;
                } else if (mortgageOptions[i].variantId == 3 && loan.activeMortgage.variantId == 4) {
                    loan.activeMortgage = mortgageOptions[i];
                    break;
                } else if (mortgageOptions[i].variantId == 4 && loan.activeMortgage.variantId == 3) {
                    loan.activeMortgage = mortgageOptions[i];
                    break;
                }
            } else {
                if (mortgageOptions[i].variantType === value && loan.typeLoan == "carLoan" ||  loan.typeLoan == "newCarLoan") {
                    console.log("outside mortgage options " + mortgageOptions[i].glConfigurationList[0].currency == loan.currency);
                    if (mortgageOptions[i].glConfigurationList[0].currency == loan.currency) {
                        console.log("inside mortgage options ");
                        loan.activeMortgage = mortgageOptions[i];
                        break;
                    }


                } else if (mortgageOptions[i].variantType === value && loan.typeLoan != "carLoan" &&  loan.typeLoan != "newCarLoan") {
                    loan.activeMortgage = mortgageOptions[i];
                    break;
                }

            }
        }
        if ($.isEmptyObject(loan.activeMortgage) && (loan.typeLoan == "carLoan" ||  loan.typeLoan == "newCarLoan")) {
            //appena carico il calcolatore loan.currency non è caricato prendo il caso di default
            console.log("dentro");
            loan.activeMortgage = mortgageOptions[0];
        }

        loan['mortgage'] = loan.activeMortgage.variantType;

    };


    /**
     * Get Default Mortgage
     *
     */
    this.getDefaultMortgage = function() {

        if (loan.activeVariant) {

            var mortgageOptions = loan.activeVariant.glProductVariantList;
            var numberOfMortgage = mortgageOptions.length;
            var label = '';
            var mortgageFound = false;

            // cicle all the martgage options
            for (var i = 0; i < numberOfMortgage; i++) {

                if (mortgageOptions[i].default === true) {

                    label = mortgageOptions[i].variantType;
                    loan['mortgage'] = label;
                    mortgageFound = true;
                    break;

                }

            }

            if (!mortgageFound) label = mortgageOptions[0].variantType;

            loan['mortgage'] = label;

            return label;

        }

    };


    /**
     * Set Active Currency
     *
     */
    this.setActiveCurrency = function(value) {

        var currencyOptions = loan.activeMortgage.glConfigurationList;
        var numberOfCurrency = currencyOptions.length;

        // cicle all the currencies
        for (var i = 0; i < numberOfCurrency; i++) {

            if (currencyOptions[i].currency === value) {

                loan.activeCurrency = currencyOptions[i];
                break;

            }

        }

        if (loan.typeLoan == 'Universal Loan') {
            if (value == 'EUR') {
                loan.secondCurrency = 'RSD';
            }
        }

    };

    /**
     * Set Active Currency car loan
     *
     */
    this.setActiveCurrencyCarLoan = function(value) {

        // loan.activeCurrency.currency = value;
        loan.currency = value;

    };


    /**
     * Get Default Currency
     *
     */
    this.getDefaultCurrency = function() {

        var currencyOptions = loan.activeMortgage.glConfigurationList;
        var numberOfCurrency = currencyOptions.length;
        var label = '';

        // cicle all the currencies
        for (var i = 0; i < numberOfCurrency; i++) {

            if (currencyOptions[i].default === true) {

                label = currencyOptions[i].currency;
                break;

            }

        }

        return label;

    };


    /**
     * Set Active Interest Type
     *
     */
    this.setActiveInterestType = function(value) {
        var interestOptions = loan.activeTab.data.interest;
        var numberOfInterests = interestOptions.length;

        // cicle all interest rates
        for (var i = 0; i < numberOfInterests; i++) {

            if (interestOptions[i].interestCode === value) {

                loan.activeInterestType = interestOptions[i];
                loan['interestRateType'] = value;
                break;

            }

        }

    };


    /**
     * Get Default Interest Type
     *
     */
    this.getDefaultInterestType = function() {

        var interestOptions = loan.activeTab.data.interest;
        var numberOfInterests = interestOptions.length;
        var label = '';

        // cicle all interest rates
        for (var i = 0; i < numberOfInterests; i++) {

            if (interestOptions[i].default === true) {

                label = interestOptions[i].interestCode;
                break;

            }

        }

        return label;

    };


    /**
     * Get Calculator Inputs
     *
     */
    this.getCalculatorInputs = function() {

        var inputs = $('[data-algorithm-input]', loan.activeCalculator);
        var numberOfInputs = inputs.length;
        var tenorForUniversal = 0;
        var tenorTreUniversal = 0;
        var tenorQuattroUniversal = 0;
        for (var i = 0; i < numberOfInputs; i++) {

            // get name
            var inputLabel = inputs[i].getAttribute('data-algorithm-input');

            // get value
            var inputValue = inputs[i].value;

            //            if (loan.typeLoan == 'Universal Loan') {
            //                if (inputLabel == 'tenor') {
            //                    if ($(inputs[i]).hasClass('selected-tenor')) {
            //                    	if($(inputs[i]).siblings("input[class^=rangeslider]").hasClass("rangeslider--3")){
            //                    		tenorTreUniversal = inputs[i].value;
            //                    	} else if ($(inputs[i]).siblings("input[class^=rangeslider]").hasClass("rangeslider--4")){
            //                    		tenorQuattroUniversal = inputs[i].value;
            //                    	} else {
            //                    		tenorForUniversal = inputs[i].value;
            //                    	}
            //                 
            //                    }
            //                }
            //            }

            // remove dots from loan amount
            if (inputLabel === 'loanAmount') {
              //inputValue = inputValue.replaceAll(/\./g, '').replaceAll(/\s/g, '');
                inputValue = inputValue.split(/\./g).join('').split(/\s/g).join('');
            }
            //downPayment
            if (inputLabel === 'downPayment') {
              //inputValue = inputValue.replaceAll(/\./g, '').replaceAll(/\s/g, '');
                inputValue = inputValue.split(/\./g).join('').split(/\s/g).join('');
            }

            // mortgage
            if (inputLabel === 'mortgage') {
                inputValue = $('input[name=radio]:checked', '[data-algorithm-input="mortgage"]', loan.activeCalculator).val();
            }

            // parse numbers
            if (inputLabel !== 'currency' &&
                inputLabel !== 'mortgage' &&
                inputLabel !== 'fixedInterestRate' &&
                inputLabel !== 'variableInterestRate' &&
                inputLabel !== 'middleExchangeRate' &&
                inputLabel !== 'newInterestRate' &&
                inputLabel !== 'newMiddleExchangeRate' &&
                inputLabel !== 'nominalInterestRate' &&
                inputLabel !== 'newNominalInterestRate') inputValue = parseFloat(inputValue);

            // set global property
            loan[inputLabel] = inputValue;

        }
        //        if (loan.typeLoan == 'Universal Loan') {
        //            loan['tenor'] = tenorForUniversal;
        //            loan['tenorTre'] = tenorTreUniversal;
        //            loan['tenorQuattro'] = tenorQuattroUniversal;
        //        }
    };

    /**
     * Update Tabs Number
     *
     */
    this.updateTabsNumber = function() {

        var tabs = loan.activeVariant.glGenericCalculationList;
        var numberOftabs = tabs.length;
        var tabsHTML = $('.com16__tabMenu');
        var tabsWrapper = $('.com16__tabContainer');

        // hide tabs HTML if there's only one tab
        if (numberOftabs <= 1) {
            tabsHTML.hide();
            tabsWrapper.css('padding-top', '40px');
        } else {
            tabsHTML.show();
            tabsWrapper.removeAttr("style");
        }

    };


    /**
     * Append Calculator Outputs
     *
     */
    this.appendCalculatorOutputs = function() {

        var outputs = $('[data-algorithm-output]', loan.activeCalculator);
        var getLoanButton = $('.com16__buttonCover .btn', loan.activeCalculator);
        //console.log(outputs);
        // if there are errors
        //console.log("errorState" + loan.errorState + "loan" +  isNaN(loan.loanAmount) + "downError" + loan.errorDownState)

        if (loan.errorState === true || isNaN(loan.loanAmount) || loan.errorDownState === true || loan.loanAmount == 0) {
            $('[data-algorithm-output]:not([data-algorithm-output=currency])').text('-');
            if (loan.typeLoan == 'Universal Loan') {
                $('[data-algorithm-output]:not([data-algorithm-output=secondCurrency])').text('-');
            }
            getLoanButton.addClass('disabled');
            return;
        }

        // enable button
        getLoanButton.removeClass('disabled');

        outputs.each(function() {

            var inputLabel = $(this).attr('data-algorithm-output');
            var outputValue = loan[inputLabel];

            // format outputs
            if ((inputLabel === 'monthlyInstallment') || (inputLabel === 'firstMonthlyInstallment') || (inputLabel === 'secondMonthlyInstallment') || (inputLabel === 'secondInterestRate') || (inputLabel === 'firstInterestRate')) {
                outputValue = number_format(loan[inputLabel], 2, genericSettings.decimal, genericSettings.separator);
            }
            if (loan.typeLoan == 'Universal Loan') {

                if (inputLabel == 'firstMonthlyInstallmentAfterVInterestRateExchangeRate') {
                    outputValue = number_format(loan[inputLabel], 2, genericSettings.decimal, genericSettings.separator);
                }
                if (inputLabel == 'firstMonthlyInstallmentAfterExchangeRate') {
                    outputValue = number_format(loan[inputLabel], 2, genericSettings.decimal, genericSettings.separator);
                }
                if (inputLabel == 'firstMonthlyInstallmentRsd') {
                    outputValue = number_format(loan[inputLabel], 2, genericSettings.decimal, genericSettings.separator);
                }
                if (inputLabel == 'firstMonthlyInstallmentEur') {
                    outputValue = number_format(loan[inputLabel], 2, genericSettings.decimal, genericSettings.separator);
                }
                if (inputLabel == 'firstMonthlyInstallmentEurInterestRate') {
                    outputValue = number_format(loan[inputLabel], 2, genericSettings.decimal, genericSettings.separator);
                }
                if (inputLabel == 'firstMonthlyInstallmentRsdInterestRate') {
                    outputValue = number_format(loan[inputLabel], 2, genericSettings.decimal, genericSettings.separator);
                }
                if (inputLabel === 'amountToRepayRsd') {
                    outputValue = number_format(loan[inputLabel], 2, genericSettings.decimal, genericSettings.separator);
                }
                if (inputLabel == 'currency') {
                    var siblings = $(this).siblings();
                    for (i = 0; i < siblings.length; i++) {
                        if ($(siblings[i]).attr('data-algorithm-output') == 'firstMonthlyInstallmentEurInterestRate') {
                            outputValue = 'EUR';
                        }
                    }
                }

            }
            if (inputLabel === 'loanAmount' || inputLabel === 'aprc' || inputLabel === 'aprc2') {
                outputValue = number_format(loan[inputLabel] - loan.downPayment, 2, genericSettings.decimal, genericSettings.separator);
            }

            if (inputLabel === 'amountToRepay') {
                outputValue = number_format(loan[inputLabel] + loan.fee, 2, genericSettings.decimal, genericSettings.separator);
            }


            if (inputLabel === 'tenor' && loan.tenorUnit === 'YEARS') {
                outputValue = loan.tenor / 12;
            }

            if (inputLabel === 'approval_cost') {
                outputValue = loan.formatFeeOutput(outputValue);
            }

            if (inputLabel === 'notary_cost' && loan.isWithMortgage) {
                outputValue = loan.formatFeeOutput(outputValue);
            }
			
			if (inputLabel === "downPayment"){
				if(loan.currency != "RSD"){
					$("[data-show-downPayment]").attr("data-show-downPayment", true);
				} else {
					$("[data-show-downPayment]").attr("data-show-downPayment", false);
				}
			}
			
            if (inputLabel === 'fee') {
                outputValue = loan.formatFeeOutput(outputValue);
            }
            if (inputLabel === 'customer') {
               	if(outputValue == true){
               		$("[data-show-customer]").attr("data-show-customer", true);
               		$("[data-show-notcustomer]").attr("data-show-notcustomer", false);
               		outputValue = calculatorLabels["WITHSALARYMOBILE"];
               	} else {
               	    $("[data-show-customer]").attr("data-show-customer", false);
               		$("[data-show-notcustomer]").attr("data-show-notcustomer", true);
               		outputValue = calculatorLabels["WITHOUTSALARYMOBILE"];
               	}
            }
            
            if (inputLabel === 'clientSegment') {
               	if(outputValue == true){
               		$("[data-show-mass]").attr("data-show-mass", true);
               		$("[data-show-uppermass]").attr("data-show-uppermass", false);
               	} else {
               	    $("[data-show-mass]").attr("data-show-mass", false);
               		$("[data-show-uppermass]").attr("data-show-uppermass", true);
               	}
            }
            
            if (inputLabel === 'otherLoan') {
               	if(outputValue == true){
               		$("[data-show-otherloan]").attr("data-show-otherloan", true);
               		$("[data-show-nototherloan]").attr("data-show-nototherloan", false);
               		outputValue = calculatorLabels["WITHOTHERLOAN"];
               	} else {
               	    $("[data-show-otherloan]").attr("data-show-otherloan", false);
               		$("[data-show-nototherloan]").attr("data-show-nototherloan", true);
               		outputValue = calculatorLabels["WITHOUTOTHERLOAN"];
               	}
               	// RIMUOVERE TUTTO QUESTO IF SE SI SCEGLIE DI MOSTRARE SEMPRE L'OPZIONE OTHER LOAN
               	/*if($(".otherLoanOutputMobile").length > 0){
        	    	if(loan.activeInterestType.interestCode != "FIXED" || loan.customer == false){
        	    		$(".otherLoanOutputMobile").addClass("hide");
        	    	}else{
        	    		$(".otherLoanOutputMobile").removeClass("hide");
        	    	}
            	}*/
            }
            
			if( inputLabel === 'firstInterestRateCode' ) {
				if( loan.activeInterestType.interestCode.toUpperCase() == "FIXED"){
					outputValue = calculatorLabels["FIXEDMOBILE"];
				} else {
					outputValue = calculatorLabels["VARIABLEMOBILE"];
				}					
			}

            $(this).text(outputValue);

        });

    };


    /**
     * Format Fee Output
     *
     */
    this.formatFeeOutput = function(outputValue) {

        var feeCurrency = $('[data-fixed-currency]');

        if ((outputValue === null) || (outputValue === undefined)) {

            // show 'no fee' label & hide currency
            outputValue = calculatorLabels['NO_FEE'];
            feeCurrency.addClass('hide');

        } else {

            outputValue = number_format(outputValue, 2, genericSettings.decimal, genericSettings.separator);
            // show currency
            feeCurrency.removeClass('hide');

        }

        return outputValue;

    };


    /**
     * Format Money Inputs
     *
     */
    this.formatMoneyInputs = function() {

        var inputToFormat = $('*[data-format-currency]');

        if (inputToFormat.length > 0) {

            inputToFormat.each(function() {

                var cleave = new Cleave($(this), {

                    delimiter: genericSettings.separator,
                    numeral: true,
                    numeralDecimalMark: genericSettings.decimal,
                    numeralDecimalScale: 2,
                    numeralThousandsGroupStyle: 'thousand'

                });

            });

        }

    };

    this.pianoUniversal = function(loanAmount, loanDurationInYear, interestRate, periodicy) {
            var lang_calculator = $('input[name=loanCalculatorLanguage]').val();
            var description = "Description";
            if(lang_calculator == 'sr'){
             	description = "Opis";
            }
            var piano = [];
            var pianoTopPage = [];
            var finalArrayTopPage = [];
            if (currentSelectedUniversalCase == 'rsd-variable') {
                /*
                     No. of installment
                    Payment Date
                    Loan Payout
                    Nominal interest rate
                    Monthly installment
                    Principal Payment (quota capitale)
                    Interest Payment (interessi pagati sulla rata)
                    Loan amount
                    Description
                    
                     --Top page rows--
                     
                    Date of the Repayment Plan 
                    Loan amount  
                    Repayment Period 
                    Nominal interest rate  
                    New  value of nominal interest rate
                    Monthly installment 
                    Monthly installment after after change of variable part of interest rate
                    
                 */
                var m = loanAmount;
                var n = loanDurationInYear;
                var perc = interestRate;
                var i = perc / 100;
                var paymentDate = new Date();

                // periodicità dei pagamenti: 12: mensile, 
                var k = (!periodicy) ? 12 : periodicy;

                // numero totale di pagamenti
                var kn = k * n;

                var repaymentDates = loan.calculateRepaymentDates(kn, paymentDate);

                // tasso di interesse periodico
                var ik = i / k;

                var ikpiu1 = ik + 1

                // calcolo della rata sulla 
                var rata = m * ik / (1 - Math.pow(ikpiu1, -k * n));

                // rata arrotondata a 2 decimali 
                rata = round(rata, 4);

                i = 0;
                // quota interessi 
                var Ii = 0;

                // Interessi totali 
                var ITot = 0;

                // quota capitale 
                var Ci = 0;

                // Debito residuo 
                var Di = m;

                // Debito Estinto 
                var Ei = 0;

                // calcolo del piano di ammortamento 
                var convertRate = parseFloat(middleExchangeRateActive.toString().replace(",", "."));
                var eurRate = parseFloat(rata);
                if (loan.activeCurrency.currency == "EUR") {
                    eurRate = parseFloat(rata) * convertRate;
                }
                pianoTopPage.push([
                    repaymentDates[0],
                    number_format(parseFloat(loan.loanAmount), 2, genericSettings.decimal, genericSettings.separator) + " " + loan.activeCurrency.currency,
                    loan.tenor + ' months',
                    number_format(parseFloat(loan.nominalInterestRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator) + ' % ' + "(" + number_format(parseFloat(loan.fixedInterestRate), 2, genericSettings.decimal, genericSettings.separator) + " %" + " + " + number_format(parseFloat(loan.variableInterestRate), 2, genericSettings.decimal, genericSettings.separator) + " %" + " )", number_format(parseFloat(loan.newNominalInterestRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator) + ' %' + "(" + number_format(parseFloat(loan.fixedInterestRate), 2, genericSettings.decimal, genericSettings.separator) + " %" + " + " + number_format(parseFloat(loan.newInterestRate), 2, genericSettings.decimal, genericSettings.separator) + " %" + " )",
                    number_format(parseFloat(loan.firstMonthlyInstallmentRsd.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator) + " " + loan.activeCurrency.currency,
                    number_format(parseFloat(eurRate), 2, genericSettings.decimal, genericSettings.separator) + " " + loan.activeCurrency.currency
                ]);
                var firstLoanStatus = "";
                finalArrayTopPage.push(pianoTopPage[0]);
                sessionStorage.setItem("pianoTopPage", JSON.stringify(finalArrayTopPage));
                for (i = 1; i <= kn; i++) {

                    Ii = round(ik * Di, 4);
                    Ci = round(rata - Ii, 4);
                    Di = round(Di - Ci, 4);
                    Ei = round(Ei + Ci, 4);
                    ITot = round(ITot + Ii, 4);

                    // gestione ultima rata
                    if (i == kn) {
                        rata = round(rata + Di, 4);
                        Ei = round(Ei + Di, 4);
                        Ci = round(Ci + Di, 4);
                        Di = 0;
                    }
                    if (i == 1) {
                        firstLoanStatus = number_format(parseFloat(m), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency;
                    } else {
                        firstLoanStatus = "-";
                    }
                    piano.push([
                        i,
                        repaymentDates[i],
                        firstLoanStatus,
                        number_format(parseFloat(perc), 2, genericSettings.decimal, genericSettings.separator) + " %",
                        number_format(parseFloat(rata), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        number_format(parseFloat(Ci), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        number_format(parseFloat(Ii), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        number_format(parseFloat(Di), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        description
                    ]);

                }
            } else if (currentSelectedUniversalCase == 'rsd-fixed') {
                /*
                No. of installment
                Payment Date
                Loan Payout
                Monthly installment
                Principal Payment
                Interest Payment
                Loan status
                Description
                 --Top page rows--
                 
                Date of the Repayment Plan 
                Loan amount  
                Repayment Period 
                Nominal interest rate  
                Monthly installment 
                */
                var m = loanAmount;
                var n = loanDurationInYear;
                var perc = interestRate;
                var i = perc / 100;
                var paymentDate = new Date();

                // periodicità dei pagamenti: 12: mensile, 
                var k = (!periodicy) ? 12 : periodicy;

                // numero totale di pagamenti
                var kn = k * n;

                var repaymentDates = loan.calculateRepaymentDates(kn, paymentDate);

                // tasso di interesse periodico
                var ik = i / k;

                var ikpiu1 = ik + 1

                // calcolo della rata sulla 
                var rata = m * ik / (1 - Math.pow(ikpiu1, -k * n));

                // rata arrotondata a 2 decimali 
                rata = round(rata, 4);

                i = 0;
                // quota interessi 
                var Ii = 0;

                // Interessi totali 
                var ITot = 0;

                // quota capitale 
                var Ci = 0;

                // Debito residuo 
                var Di = m;

                // Debito Estinto 
                var Ei = 0;

                // calcolo del piano di ammortamento
                pianoTopPage.push([
                    repaymentDates[0],
                    number_format(parseFloat(m), 2, genericSettings.decimal, genericSettings.separator) + " " + loan.activeCurrency.currency,
                    loan.tenor + ' months',
                    number_format(parseFloat(perc), 2, genericSettings.decimal, genericSettings.separator) + " %",
                    number_format(parseFloat(rata), 2, genericSettings.decimal, genericSettings.separator) + " " + loan.activeCurrency.currency
                ]);
                var firstLoanStatus = "";
                finalArrayTopPage.push(pianoTopPage[0]);
                sessionStorage.setItem("pianoTopPage", JSON.stringify(finalArrayTopPage));
                for (i = 1; i <= kn; i++) {

                    Ii = round(ik * Di, 4);
                    Ci = round(rata - Ii, 4);
                    Di = round(Di - Ci, 4);
                    Ei = round(Ei + Ci, 4);
                    ITot = round(ITot + Ii, 4);

                    // gestione ultima rata
                    if (i == kn) {
                        rata = round(rata + Di, 4);
                        Ei = round(Ei + Di, 4);
                        Ci = round(Ci + Di, 4);
                        Di = 0;
                    }
                    if (i == 1) {
                        firstLoanStatus = number_format(parseFloat(m), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency;
                    } else {
                        firstLoanStatus = "-";
                    }
                    piano.push([
                        i,
                        repaymentDates[i],
                        firstLoanStatus,
                        number_format(parseFloat(rata), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        number_format(parseFloat(Ci), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        number_format(parseFloat(Ii), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        number_format(parseFloat(Di), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        description
                    ]);

                }
            } else if (currentSelectedUniversalCase == 'eur-fixed') {
                /*
                 No. of installment
                 Payment Date
                 Loan Payout
                 Middle Exchange rate
                 Monthly installment
                 Principal Payment
                 Interest Payment
                 Loan status
                 Description
                  --Top page rows--
                  
                 Date of the Repayment Plan 
                 Loan amount  
                 Repayment period
                 Nominal interest rate   
                 Middle Exchange rate
                 New value of middle exchange rate 
                 Monthly installment
                 Monthly installment after change of exchange rate
 
 
                 */
                var m = loanAmount;
                var n = loanDurationInYear;
                var perc = interestRate;
                var i = perc / 100;
                var paymentDate = new Date();

                // periodicità dei pagamenti: 12: mensile, 
                var k = (!periodicy) ? 12 : periodicy;

                // numero totale di pagamenti
                var kn = k * n;

                var repaymentDates = loan.calculateRepaymentDates(kn, paymentDate);

                // tasso di interesse periodico
                var ik = i / k;

                var ikpiu1 = ik + 1

                // calcolo della rata sulla 
                var rata = m * ik / (1 - Math.pow(ikpiu1, -k * n));

                // rata arrotondata a 2 decimali 
                rata = round(rata, 4);

                i = 0;
                // quota interessi 
                var Ii = 0;

                // Interessi totali 
                var ITot = 0;

                // quota capitale 
                var Ci = 0;

                // Debito residuo 
                var Di = m;

                // Debito Estinto 
                var Ei = 0;

                var monthlyAfterExchange = rata * parseFloat(loan.newMiddleExchangeRate.toString().replace(",", "."));
                // calcolo del piano di ammortamento 
                pianoTopPage.push([
                    repaymentDates[0],
                    number_format(parseFloat(loan.loanAmount), 2, genericSettings.decimal, genericSettings.separator) + " " + loan.activeCurrency.currency,
                    loan.tenor + ' months',
                    number_format(parseFloat(perc), 2, genericSettings.decimal, genericSettings.separator) + ' %',
                    number_format(parseFloat(loan.middleExchangeRate), 2, genericSettings.decimal, genericSettings.separator) + ' RSD',
                    number_format(parseFloat(loan.newMiddleExchangeRate), 2, genericSettings.decimal, genericSettings.separator) + " RSD",
                    number_format(parseFloat(rata), 2, genericSettings.decimal, genericSettings.separator) + " " + loan.activeCurrency.currency,
                    number_format(parseFloat(monthlyAfterExchange), 2, genericSettings.decimal, genericSettings.separator) + " RSD"
                ]);
                finalArrayTopPage.push(pianoTopPage[0]);
                sessionStorage.setItem("pianoTopPage", JSON.stringify(finalArrayTopPage));
                var firstLoanStatus = "";
                var rangeVal = parseInt($(".rangeslider--3").val());
                var rangeVal4 = parseInt($(".rangeslider--4").val());
                var middleExchangeRateActiveToUse = 0;
                for (i = 1; i <= kn; i++) {

                    Ii = round(ik * Di, 4);
                    Ci = round(rata - Ii, 4);
                    Di = round(Di - Ci, 4);
                    Ei = round(Ei + Ci, 4);
                    ITot = round(ITot + Ii, 4);

                    // gestione ultima rata
                    if (i == kn) {
                        rata = round(rata + Di, 4);
                        Ei = round(Ei + Di, 4);
                        Ci = round(Ci + Di, 4);
                        Di = 0;
                    }
                    if (i == 1) {
                        firstLoanStatus = number_format(parseFloat(m), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency;
                    } else {
                        firstLoanStatus = "-";
                    }

                    if (i < rangeVal4) {
                        middleExchangeRateActiveToUse = loan.middleExchangeRate;
                    } else {
                        middleExchangeRateActiveToUse = loan.newMiddleExchangeRate;
                    }
                    piano.push([
                        i,
                        repaymentDates[i],
                        firstLoanStatus,
                        middleExchangeRateActiveToUse + " RSD",
                        number_format(parseFloat(rata), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        number_format(parseFloat(Ci), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        number_format(parseFloat(Ii), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        number_format(parseFloat(Di), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        description
                    ]);

                }
            } else if (currentSelectedUniversalCase == 'eur-variable') {
                /*
                     No of the instalment
                     Payment Date
                     Loan Payout
                     Nominal interest rate
                     Middle Exchange Rate 
                     Interest payment 
                     Monthly instalment
                     Principal Payment
                     Loan Amount
                     Description
                  --Top page rows--
                  
                     Date of the Repayment Plan
                     Loan Amount
                     Repayment Period
                     Nominal Interest Rate
                     New value of nominal interest rate
                     Middle Exchange Rate
                     New Value of Middle Exchange Rate
                     Monthly instalment in RSD
                     Monthly instalment after change of variable part of interest rate in EUR
                     Monthly instalment after change of variable part of interest rate in RSD
                     Monthly instalment after change of variable part of interest rate and middle exchange rate (RSD)
 
 
 
                 */
                var m = loanAmount;
                var n = loanDurationInYear;
                var perc = interestRate;
                var i = perc / 100;
                var paymentDate = new Date();

                // periodicità dei pagamenti: 12: mensile, 
                var k = (!periodicy) ? 12 : periodicy;

                // numero totale di pagamenti
                var kn = k * n;

                var repaymentDates = loan.calculateRepaymentDates(kn, paymentDate);

                // tasso di interesse periodico
                var ik = i / k;

                var ikpiu1 = ik + 1

                // calcolo della rata sulla 
                var rata = m * ik / (1 - Math.pow(ikpiu1, -k * n));
                var rataOrig = m * (loan.firstInterestRate / 100 / k) * k / (1 - Math.pow(loan.firstInterestRate / 100 / k + 1, -k * n));

                // rata arrotondata a 2 decimali 
                rata = round(rata, 4);

                i = 0;
                // quota interessi 
                var Ii = 0;

                // Interessi totali 
                var ITot = 0;

                // quota capitale 
                var Ci = 0;

                // Debito residuo 
                var Di = m;

                // Debito Estinto 
                var Ei = 0;

                // calcolo del piano di ammortamento 
                var convertRate = loan.middleExchangeRate.toString().replace(",", ".");
                pianoTopPage.push([
                    repaymentDates[0],
                    number_format(parseFloat(loan.loanAmount), 2, genericSettings.decimal, genericSettings.separator) + " " + loan.activeCurrency.currency,
                    loan.tenor + ' months',
                    number_format(parseFloat(loan.nominalInterestRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator) + ' % ' + "(" + number_format(parseFloat(loan.fixedInterestRate), 2, genericSettings.decimal, genericSettings.separator) + " %" + " + " + number_format(parseFloat(loan.variableInterestRate), 2, genericSettings.decimal, genericSettings.separator) + " %" + " )",
                    number_format(parseFloat(loan.newNominalInterestRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator) + ' %' + "(" + number_format(parseFloat(loan.fixedInterestRate), 2, genericSettings.decimal, genericSettings.separator) + " %" + " + " + number_format(parseFloat(loan.newInterestRate), 2, genericSettings.decimal, genericSettings.separator) + " %" + " )",
                    number_format(parseFloat(loan.middleExchangeRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator) + ' RSD',
                    number_format(parseFloat(loan.newMiddleExchangeRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator) + ' RSD',
                    number_format(parseFloat(loan.firstMonthlyInstallmentRsd.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator) + " RSD",
                    number_format(parseFloat(rata), 2, genericSettings.decimal, genericSettings.separator) + " " + loan.activeCurrency.currency,
                    number_format(parseFloat(loan.firstMonthlyInstallmentRsdInterestRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator) + " RSD",
                    number_format(parseFloat(loan.firstMonthlyInstallmentAfterVInterestRateExchangeRate.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator) + " RSD"
                ]);
                finalArrayTopPage.push(pianoTopPage[0]);
                sessionStorage.setItem("pianoTopPage", JSON.stringify(finalArrayTopPage));
                var firstLoanStatus = "";
                var rangeVal = parseInt($(".rangeslider--3").val());
                var rangeVal4 = parseInt($(".rangeslider--4").val());
                var middleExchangeRateActiveToUse = 0;
                for (i = 1; i <= kn; i++) {

                    Ii = round(ik * Di, 4);
                    Ci = round(rata - Ii, 4);
                    Di = round(Di - Ci, 4);
                    Ei = round(Ei + Ci, 4);
                    ITot = round(ITot + Ii, 4);

                    // gestione ultima rata
                    if (i == kn) {
                        rata = round(rata + Di, 4);
                        Ei = round(Ei + Di, 4);
                        Ci = round(Ci + Di, 4);
                        Di = 0;
                    }

                    if (i == 1) {
                        firstLoanStatus = number_format(parseFloat(m), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency;
                    } else {
                        firstLoanStatus = "-";
                    }

                    if (i < rangeVal4) {
                        middleExchangeRateActiveToUse = loan.middleExchangeRate;
                    } else {
                        middleExchangeRateActiveToUse = loan.newMiddleExchangeRate;
                    }
                    if (kn < loan.tenor) {
                        middleExchangeRateActiveToUse = loan.newMiddleExchangeRate;
                    }

                    piano.push([
                        i,
                        repaymentDates[i],
                        firstLoanStatus,
                        number_format(parseFloat(perc), 2, genericSettings.decimal, genericSettings.separator) + " %",
                        number_format(parseFloat(middleExchangeRateActiveToUse.toString().replace(",", ".")), 2, genericSettings.decimal, genericSettings.separator) + " RSD",
                        number_format(parseFloat(Ci), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        number_format(parseFloat(rata), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        number_format(parseFloat(Ii), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        number_format(parseFloat(Di), 2, genericSettings.decimal, genericSettings.separator) + ' ' + loan.activeCurrency.currency,
                        description
                    ]);

                }
            }
            return piano;
        }
        /**
         * Calculate the loan payment plan 
         * returns a matrix as follow 
         * [
         * 	   [0: index , 
         * 		1: total interest payed , 
         * 		2: montly installment, 
         * 		3: capital part 
         * 		4: interest part
         * 		5: residual debit
         * 		6: payed debit]
         *  ...
         *  ]
         */
    this.piano = function(loanAmount, loanDurationInYear, interestRate, periodicy) {
        // piano di ammortamento
        var piano = [];
        var m = loanAmount;
        var n = loanDurationInYear;
        var perc = interestRate;
        var i = perc / 100;

        // periodicità dei pagamenti: 12: mensile, 
        var k = (!periodicy) ? 12 : periodicy;

        // numero totale di pagamenti
        var kn = k * n;

        // tasso di interesse periodico
        var ik = i / k;

        var ikpiu1 = ik + 1

        // calcolo della rata sulla 
        var rata = m * ik / (1 - Math.pow(ikpiu1, -k * n));

        // rata arrotondata a 2 decimali 
        rata = round(rata, 4);

        i = 0;
        // quota interessi 
        var Ii = 0;

        // Interessi totali 
        var ITot = 0;

        // quota capitale 
        var Ci = 0;

        // Debito residuo 
        var Di = m;

        // Debito Estinto 
        var Ei = 0;

        // calcolo del piano di ammortamento 
        for (i = 1; i <= kn; i++) {

            Ii = round(ik * Di, 4);
            Ci = round(rata - Ii, 4);
            Di = round(Di - Ci, 4);
            Ei = round(Ei + Ci, 4);
            ITot = round(ITot + Ii, 4);

            // gestione ultima rata
            if (i == kn) {
                rata = round(rata + Di, 4);
                Ei = round(Ei + Di, 4);
                Ci = round(Ci + Di, 4);
                Di = 0;
            }

            piano.push([
                i, ITot, rata, Ci, Ii, Di, Ei






            ]);

        }

        return piano;

    };
    
    /**
     * Calculate the loan payment plan for MORTGAGELOAN
     * returns a matrix as follow 
     * [
     * 	   [0: index , 
     * 		1: total interest payed , 
     * 		2: montly installment, 
     * 		3: capital part 
     * 		4: interest part
     * 		5: residual debit
     * 		6: payed debit]
     *  ...
     *  ]
     */
    this.pianoMortgageLoan = function(loanAmount, loanDurationInYear, interestRate, periodicy) {
	    // piano di ammortamento
	    var piano = [];
	    var m = loanAmount;
	    var n = loanDurationInYear;
	    var perc = interestRate;
	    var i = perc / 100;
	
	    // periodicità dei pagamenti: 12: mensile, 
	    var k = (!periodicy) ? 12 : periodicy;
	
	    // numero totale di pagamenti
	    var kn = k * n;
	
	    // tasso di interesse periodico
	    var ik = i / 360*30.5;
	    if($('[name="productId"]').val() == "24" && $('#hiddenproductid').val() == "50091" ){
	    	ik = i / 360*30.421;
	    }
	
	    var ikpiu1 = ik + 1;
	
	    // calcolo della rata sulla 
	    var rata = m * ik / (1 - Math.pow(ikpiu1, -k * n));
	
	    // rata arrotondata a 2 decimali 
	    rata = round(rata, 4);
	
	    i = 0;
	    // quota interessi 
	    var Ii = 0;
	
	    // Interessi totali 
	    var ITot = 0;
	
	    // quota capitale 
	    var Ci = 0;
	
	    // Debito residuo 
	    var Di = m;
	
	    // Debito Estinto 
	    var Ei = 0;
	
	    // calcolo del piano di ammortamento 
	    for (i = 1; i <= kn; i++) {
	
	        Ii = round(ik * Di, 4);
	        Ci = round(rata - Ii, 4);
	        Di = round(Di - Ci, 4);
	        Ei = round(Ei + Ci, 4);
	        ITot = round(ITot + Ii, 4);
	
	        // gestione ultima rata
	        if (i == kn) {
	            rata = round(rata + Di, 4);
	            Ei = round(Ei + Di, 4);
	            Ci = round(Ci + Di, 4);
	            Di = 0;
	        }
	
	        piano.push([
	            i, ITot, rata, Ci, Ii, Di, Ei
	
	
	
	
	
	
	        ]);
	
	    }
	
	    return piano;
	
	};

    this.calculateRepaymentDates = function(numberPayments, dateStart) {
        var arrayDateString = [];
        var year = dateStart.getFullYear();
        var month = dateStart.getMonth();
        var day = dateStart.getDate();
        for (i = 0; i <= numberPayments; i++) {
            var d = new Date(year, month, day);
            d.setMonth(d.getMonth() + i);
            arrayDateString[i] = loan.formatDate(d);
        }


        return arrayDateString;
    }

    this.formatDate = function(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('.');
    }

    /**
     * Get the montly installment from paymentDetail
     * paymentDetail: is a row of the payment plan calculated by loan.piano
     * montlyinstallment (rata) is the second element of paymentDetail array  
     *
     */
    this.getRata = function(paymentDetail) {
        return paymentDetail[2];
    }

    /**
     * Get the residual debit from paymentDetail
     * paymentDetail: is a row of the payment plan calculated by loan.piano
     * residual debit is the 5th element of paymentDetail array  
     *
     */
    this.getDebitoRes = function(paymentDetail) {
        return (paymentDetail && paymentDetail[5] && paymentDetail[5] >= 0) ? paymentDetail[5] : 0;
    };

    /**
     * Calculate Amount To Repay
     *
     */
    this.calculateAmountToRepay = function() {
        var initialExpenses = loan.getInitialExpenses(loan.loanAmount, loan.fee, loan.notaryCost, loan.isWithMortgage);
        loan.amountToRepay = initialExpenses;

        for (i = 0; i < loan.p.length; i++) {
            loan.amountToRepay += loan.getRata(loan.p[i]);
            //console.log("amount to repay at rata : " + i + " " + loan.amountToRepay)
        }
    };
    this.calculateAmountToRepayRsd = function() {
        loan.amountToRepayRsd = 0;
        if (loan.activeCurrency.currency == 'RSD') {
            loan.amountToRepayRsd = loan.amountToRepay;
        } else {
            var rangeVal = $(".rangeslider--3").val();
            var rangeVal4 = $(".rangeslider--4").val();
            var middleExchangeRateActiveToUse = 0;
            for (i = 0; i < loan.p.length; i++) {
                if (currentSelectedUniversalCase == "eur-fixed" || currentSelectedUniversalCase == "eur-variable") {
                    if (i < rangeVal4) {
                        middleExchangeRateActiveToUse = loan.middleExchangeRate;
                    } else {
                        middleExchangeRateActiveToUse = loan.newMiddleExchangeRate;
                    }
                } else {
                    middleExchangeRateActiveToUse = loan.middleExchangeRate;
                }
                loan.amountToRepayRsd += loan.getRata(loan.p[i]) * parseFloat(middleExchangeRateActiveToUse.toString().replace(",", "."));
                console.log("amount to repay at rata : " + i + " " + loan.amountToRepay)
            }

        }
    };


    /**
     * Calculate APRC
     * 
     */
    this.calculateAPRC_ = function(initialExpenses, periodicExpenses) {
        loan.aprc = loan.calcAprc(loan.paymentsHistoryFirstPeriod, (loan.loanAmount - initialExpenses));
        loan.aprc = loan.aprc * 100;
    }



    /**
     * Calculate APRC
     *
     */
    this.calculateAPRC = function(initialExpenses, periodicExpenses) {

        var m = loan.loanAmount;
        if (m < 0) return;
        var si = initialExpenses;
        if (si < 0) return;
        var r = loan.firstMonthlyInstallment;
        if (r < 0) return;
        var sa = periodicExpenses;
        if (sa < 0) return;
        var n = loan.tenor / 12;
        if (n == 0) return;
        var k = 12;
        if (k == 0) return;

        rapporto = (m - si) / (r + sa);
        nk = n * k;
        if (rapporto >= nk) {

            return undefined;
        }
        var ik = loan.bisezione(0.00000000000001, 1);
        var ia = Math.pow(1 + ik, k) - 1; // tasso effettivo annuo
        ia *= 100;
        loan.aprc = ia;

    };


    /**
     * Calculate APRC2
     *
     */
    this.calculateAPRC2 = function(initialExpenses, periodicExpenses) {

        var is2PeriodLoan = loan.activeInterestType.periods === 2 && loan.activeInterestType.secondPeriod !== undefined;
        if (is2PeriodLoan && loan.paymentsHistoryWholePeriod && loan.paymentsHistoryWholePeriod.length) {

            loan.aprc2 = loan.calcAprc(loan.paymentsHistoryWholePeriod, (loan.loanAmount - initialExpenses));
            loan.aprc2 = (loan.aprc2 * 100);
        } else {
            loan.aprc2 = 0;
        }
        loan.aprc2 = loan.aprc2;

    };

    /**
     * Bisezione 
     *
     */
    this.bisezione = function(a, b) {
        fa = loan.f(a);
        if (fa == 0) return a;
        fb = loan.f(b);
        if (fb == 0) return b;
        m = (a + b) / 2;
        fm = loan.f(m);
        if (fm == 0) return m;
        if ((b - a) < 1e-8) return m;
        if (fa * fm < 0)
            return loan.bisezione(a, m)
        else
            return loan.bisezione(m, b);
    };

    /**
     * f(x) 
     *
     */
    this.f = function(x) {
        return (1 - rapporto * x) * Math.pow(1 + x, nk) - 1;
    };

    /**
     * Format 
     *
     */
    this.format = function(n) {

        var nn = Math.round(n * 1000) / 1000;
        var s = String(nn);
        var l = s.length;
        var punto = s.indexOf('.');
        if (punto < 0) s += '.00';
        if (punto == l - 1) s += '00';
        if (punto == l - 2) s += '0';
        punto = s.indexOf('.');
        s = s.substr(0, punto + 3);
        return s;
    }

    /**
     * Set Active Tab
     *
     */
    this.setActiveTab = function(defaultValue, forceOpenTab, tab) {

        // prevent not boolean values
        var tabDefaultValue = defaultValue === false ? false : true;

        // force open tab if not already open
        if (forceOpenTab) {
            var isTabOpen = $('[data-tab-default="' + tabDefaultValue + '"]').parent().hasClass('open');
            if (!isTabOpen) $('[data-tab-default="' + tabDefaultValue + '"]').trigger('click');
        }

        if (tab) {
            loan.activeTab = {
                'isDefault': tab.isDefault,
                'data': tab,
            };
            return;
        }


        // get active variant tabs array
        var tabs = loan.activeCurrency.glGenericCalculationList;
        var numberOftabs = tabs.length;
        var tabFound = false;

        for (var i = 0; i < numberOftabs; i++) {

            var isDefaultTab = tabs[i].isDefault;

            // if isDefault == true, set it
            if (isDefaultTab && isDefaultTab == defaultValue) {
                loan.activeTab = {
                    'isDefault': tabs[i].isDefault,
                    'data': tabs[i],
                };
                var tabFound = true;
                break;
            }

        }

        // if tab not founded set default
        if (!tabFound) {
            loan.activeTab = {
                'isDefault': tabs[0].isDefault,
                'data': tabs[0],
            };
        }

    };

    /**
     * Console Log Values
     *
     */
    this.consoleLogValues = function() {

        console.log('--------------------------------------');
        console.log('Active variant | ' + loan.activeVariant.productCategory);
        console.log('Active mortgage | ' + loan.activeMortgage.variantType);
        console.log('Currency | ' + loan.currency);
        console.log('Active interestType | ' + loan.activeInterestType.interestCode);
        console.log('Loan amount | ' + loan.loanAmount);
        console.log('First Interest Rate | ' + loan.firstInterestRate);
        console.log('Second Interest Rate | ' + loan.secondInterestRate);
        console.log('Third Interest Rate | ' + loan.thirdInterestRate);
        console.log('Tenor in months | ' + loan.tenor);
        console.log('Tenor unit | ' + loan.tenorUnit);
        console.log('Amount to repay | ' + loan.amountToRepay);
        console.log('Monthly installment first | ' + loan.firstMonthlyInstallment);
        console.log('Monthly installment second | ' + loan.secondMonthlyInstallment);
        console.log('APR | ' + loan.apr);
        console.log('APRC | ' + loan.aprc);
        console.log('Fee (Approval Cost) | ' + loan.fee + "%");
        console.log('Min Approval Cost | ' + loan.min_approval_cost);
        console.log('Max Approval Cost | ' + loan.max_approval_cost);
        console.log('Notary Cost | ' + loan.notaryCost);
        console.log('--------------------------------------');

    };

    this.setPianoDiAmmortamento = function() {
        sessionStorage.setItem("ammortamento", JSON.stringify(loan.repaymentPlan));
        //console.log("repaymentPlan " + loan.repaymentPlan);
        sessionStorage.setItem("currentSelectedUniversalCase", currentSelectedUniversalCase);
        window.pianoAmmortamento = loan.repaymentPlan;
    };
    
    this.updateTenorSelect = function() {
        var select = $('[data-tenor-select]', loan.activeCalculator);

        if(select) {
        	select.html('');
            loan.calculateStepIntermezzo();

            loan.stepTenor.forEach(function(i) {
                var option = $("<option value=" + i + ">" + i + "</option>");
                if(i == loan.tenor){
                	option = $("<option value=" + i + " selected>" + i + "</option>");
                }
                if (loan.checkCarLoanAndAmountThreshold()) {
                    if (i >= loan.activeTab.data.amountList[1].minimumTenor) {
                        select.append(option);
                    }
                } else {
                    select.append(option);
                }
            });

            if (loan.checkCarLoanAndAmountThreshold()) {
                var tenorMin = loan.activeTab.data.amountList[1].minimumTenor;
            } else {
                var tenorMin = loan.findTenorByIndex(0);
            }
            var tenorMax = loan.findTenorByIndex(loan.stepTenor.length - 1);
            var wrapper = select.parents('.loanDuration__wrp');
            wrapper.find('[data-min-tenor]').html(tenorMin);
            wrapper.find('[data-max-tenor]').html(tenorMax);

        }
    }

    //Check loan & down amount and check productId
    this.checkCarLoanAndAmountThreshold = function () {
        var loanAmountStep = $("input[name='borrowCarValue']", loan.activeCalculator).val();
        if (loanAmountStep != undefined) {
            loanAmountStep = parseInt(loanAmountStep.replace(JSON.parse($("#genericSettings").val()).separator, ""))
        }
        var downPayment = $("input[name='borrowDownValue']", loan.activeCalculator).val();
        if (downPayment != undefined) {
            downPayment = parseInt(downPayment.replace(JSON.parse($("#genericSettings").val()).separator, ""))
        }
        return (loan.activeVariant.productId == '40051' || loan.activeVariant.productId == '40052' || loan.activeVariant.productId == '40053') && loanAmountStep - downPayment > loan.activeInterestType.firstLoanRangeAmount;
    }


    this.updateTenorInput = function() {
        var input = $('[data-algorithm-input="loanDuration"]', loan.activeCalculator);

        if(input && input.length)
        {

            var wrapper = input.parents('.loanDuration__wrp');

            var tenorMin = loan.activeTab.data.amountList[0].minimumTenor;
            var tenorMax = loan.activeInterestType.secondPeriod ? loan.activeInterestType.secondPeriod.monthDuration : loan.activeTab.data.amountList[0].maximumTenor;
            var tenorDefault = loan.activeTab.data.amountList[0].defaultTenor;

            if (loan.activeInterestType.periods === 2 && tenorMax <= loan.activeInterestType.secondPeriod.monthDuration) {
                tenorMax = loan.activeInterestType.secondPeriod.monthDuration;
            }
            
            if (loan.activeInterestType.periods === 3 && tenorMax <= loan.activeInterestType.thirdPeriod.monthDuration) {
                tenorMax = loan.activeInterestType.thirdPeriod.monthDuration;
            }


            if (loan.tenorUnit === 'YEARS') tenorMin = tenorMin / 12;
            if (loan.tenorUnit === 'YEARS') tenorMax = tenorMax / 12;

            input.val(tenorDefault);

            input.attr('data-parsley-min', tenorMin);
            input.attr('data-parsley-max', tenorMax);

            wrapper.find('[data-min-tenor]').html(tenorMin);
            wrapper.find('[data-max-tenor]').html(tenorMax);
        }

    }

    this.changeSalaryTransferDataLayer = function(isWithSalaryTrasfer) {
        var tab = loan.activeCalculator.find('.com16__tabItem.open');
        if(isWithSalaryTrasfer)
            tab.attr('data-layer-loan-salary-transfer', '');
        else
            tab.removeAttr('data-layer-loan-salary-transfer');

    }
};

/**
 * Get class instance
 *
 */
Intesa.LoanCalculatorBIB.getInstance = function() {

    if (!window.intesa) {

        window.intesa = new Object();

    }

    if (!window.intesa.loan_calculator_bib) {

        window.intesa.loan_calculator_bib = new Intesa.LoanCalculatorBIB();

    }

    return window.intesa.loan_calculator_bib;

};
